import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  AmazonSocial,
  AppStoreSocial,
  DribbleSocial,
  FacebookSocial,
  FacilitiesAccommodationIcon,
  FacilitiesBarIcon,
  FacilitiesCafeIcon,
  FacilitiesChildFriendlyIcon,
  FacilitiesNearPublicTransportIcon,
  FacilitiesParkingIcon,
  FacilitiesPetFriendlyIcon,
  FacilitiesRestaurantIcon,
  FacilitiesRestroomIcon,
  FacilitiesSeatingIcon,
  FacilitiesTaxiIcon,
  FacilitiesWheelChairAccessIcon,
  FacilitiesWifiIcon,
  FlikrSocial,
  GithubSocial,
  GooglePlaySocial,
  InstagramSocial,
  LineSocial,
  LinkedinSocial,
  RedditSocial,
  SkypeSocial,
  SnapchatSocial,
  TiktokSocial,
  TripadvisorSocial,
  TumblrSocial,
  TwitterSocial,
  VimeoSocial,
  VkontakteSocial,
  WebSocial,
  XingSocial,
} from "../../Helper/SocialSvgIcons";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCards } from "swiper/modules";

import { IoMdPersonAdd } from "react-icons/io";
import { MdEmail } from "react-icons/md";
import { BsFillTelephoneFill, BsFillTelephonePlusFill } from "react-icons/bs";
import {
  FaBuilding,
  FaCalendarAlt,
  FaCalendarPlus,
  FaFax,
  FaGoogle,
  FaYahoo,
  FaBeer,
  FaGlobe,
  FaInfoCircle,
  FaWineGlassAlt,
  FaCoffee,
  FaCheck,
  FaTimes,
  FaUtensils,
  FaExclamationCircle,
  FaTag,
} from "react-icons/fa";

import { FaLocationDot } from "react-icons/fa6";
import { IoGlobeOutline, IoPeopleCircle } from "react-icons/io5";
import { TbBriefcase2Filled } from "react-icons/tb";
import { GoClockFill } from "react-icons/go";
import formatDate from "../../utils/FormatDate";
import { CiCalendar } from "react-icons/ci";
import { PiCigaretteBold } from "react-icons/pi";

import { useForm, Controller } from "react-hook-form";
import { AccordianComponent } from "../AccordianComponent";
import apis from "../../services";
import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { Rating, Stack } from "@mui/material";
import { debounce } from "lodash";
import { useSelector } from "react-redux";
import { getTranslatedField } from "../utils/getField";

const icons = {
  facebook: <FacebookSocial />,
  instagram: <InstagramSocial />,
  twitter: <TwitterSocial />,
  dribble: <DribbleSocial />,
  flickr: <FlikrSocial />,
  github: <GithubSocial />,
  line: <LineSocial />,
  linkedin: <LinkedinSocial />,
  reddit: <RedditSocial />,
  skype: <SkypeSocial />,
  snapchat: <SnapchatSocial />,
  tiktok: <TiktokSocial />,
  tripadvisor: <TripadvisorSocial />,
  tumblr: <TumblrSocial />,
  vimeo: <VimeoSocial />,
  vkontakte: <VkontakteSocial />,
  web: <WebSocial />,
  xing: <XingSocial />,
};
const FacilitiesIcon = {
  Accommodation: <FacilitiesAccommodationIcon />,
  Bar: <FacilitiesBarIcon />,
  Cafe: <FacilitiesCafeIcon />,
  ChildFriendly: <FacilitiesChildFriendlyIcon />,
  Parking: <FacilitiesParkingIcon />,
  PetFriendly: <FacilitiesPetFriendlyIcon />,
  Restaurant: <FacilitiesRestaurantIcon />,
  Restroom: <FacilitiesRestroomIcon />,
  Seating: <FacilitiesSeatingIcon />,
  NearPublicTransport: <FacilitiesNearPublicTransportIcon />,
  Taxi: <FacilitiesTaxiIcon />,
  WheelChairAccess: <FacilitiesWheelChairAccessIcon />,
  Wifi: <FacilitiesWifiIcon />,
};
const iconsApps = {
  googlePlay: <GooglePlaySocial />,
  appStore: <AppStoreSocial />,
  amazon: <AmazonSocial />,
};

const CustomButton = ({ text, url, backgroundColor, icon, onClick, color,textColor }) => {
  if (!text) return null;

  return (
    <button
      style={{
        background: backgroundColor,
        width: "90%",
        maxWidth: "300px",
        height: "32px",
        borderRadius: "4px",
        outline: "none",
        border: "none",
        color: textColor ? textColor : color,
        display: "flex",
        alignItems: "center",
        gap: "10px",
        justifyContent: "center",
        marginInline: "auto",
        
      }}
      onClick={onClick}
    >
      {icon}
      <Link
        to={url}
        {...(url ? { target: "_blank" } : {})}
        style={{ textDecoration: "none", color }}
      >
        {text}
      </Link>
    </button>
  );
};

const SocialMediaLinks = ({ socialLinks, icons }) => {
  if (!socialLinks) return null;

  // console.log("socialLinks", socialLinks);

  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        gap: "12px",
        width: "100%",
        maxWidth: "700px",
        justifyContent: "center",
        paddingTop: "12px",
        paddingBottom: "12px",
      }}
    >
      {Object.entries(socialLinks)
        .filter(([key, url]) => url)
        .map(([key, url]) => (
          <a
            key={key}
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#333" }}
          >
            {icons[key] || null}
          </a>
        ))}
    </div>
  );
};

const FacilitiesIconComp = ({ socialLinks, icons }) => {
  if (!socialLinks) return null;

  // console.log("socialLinks", socialLinks);

  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        gap: "12px",
        width: "100%",
        maxWidth: "700px",
        justifyContent: "center",
        paddingTop: "12px",
        paddingBottom: "12px",
      }}
    >
      {Object.entries(socialLinks)
        .filter(([key, value]) => value == "true" || value == true)
        .map(([key, url]) => (
          <a
            key={key}
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#333" }}
          >
            {icons[key] || null} {/* Render the icon if available */}
          </a>
        ))}
    </div>
  );
};

const DynamicImage = ({ data, imageKey, altText, style }) => {
  // Function to determine the image URL based on the input
  const getImageUrl = (source, key) => {
    // console.log("source chekkk", source);
    if (!source || !key) return null;
    const image = source[key];
    return typeof source?.key === "string"
      ? image
      : image instanceof File
      ? URL.createObjectURL(image)
      : image;
  };

  const imageUrl = getImageUrl(data, imageKey);

  return (
    imageUrl && (
      <div
        className="websiteLogo"
        style={{ width: "90%", marginInline: "auto" }}
      >
        <img src={imageUrl} alt={altText} style={style} />
      </div>
    )
  );
};

export const QRPreviewLanding = ({ localQrData }) => {
  // const imageUrl = localQrData?.id
  //   ? localQrData?.landing_logo
  //   : localQrData?.landing_logo instanceof File
  //   ? URL.createObjectURL(localQrData.landing_logo)
  //   : localQrData?.landing_logo;
  const { translatedData } = useSelector((state) => state?.language);
  return (
    <div
      className="layout-content showBrowser "
      style={{
        backgroundColor: localQrData?.color?.background,
        width: "100%",
        maxWidth: "700px",
        margin: "0 auto",
      }}
    >
      <div className="website-companyName">
        <p
          style={{
            fontWeight: "700",
            wordBreak: "break-all",
            color: localQrData?.text_color,
            textAlign: "center",
       
          }}
        >
          {/* {localQrData?.landing_company} */}
          {getTranslatedField(translatedData, localQrData, "landing_company")}
        </p>
      </div>
      <div>
        {/* <div className="websiteLogo">
          {localQrData?.landing_logo && (
            <img  
              src={imageUrl}
              alt="Company Logo"
              style={{ width: "40px", height: "40px", objectFit: "contain" }}
            />
          )}
        </div> */}
        <DynamicImage
          data={localQrData}
          imageKey="landing_logo"
          altText="Company Logo"
          style={{
            width: "100%",
            height: "120px",
            objectFit: "contain",
            borderRadius: "12px",
          }}
        />
        <div
          className="con-white"
          style={{
            background: "#fff",
            paddingTop: "10px",
            // paddingBottom: "10px",
            marginTop: "8px",
          }}
        >
          <p
            style={{
              fontWeight: "700",
              wordBreak: "break-all",
              color: localQrData?.text_color,
              textAlign: "center",
                   marginBottom:"0px"
            }}
          >
            {/* {localQrData?.landing_title} */}
            {getTranslatedField(translatedData, localQrData, "landing_title")}
          </p>
          <h6
            style={{
              fontWeight: "400",
              wordBreak: "break-all",
              color: localQrData?.text_color,
              textAlign: "center",
            }}
          >
            {/* {localQrData?.landing_subtitle} */}
            {getTranslatedField(
              translatedData,
              localQrData,
              "landing_subtitle"
            )}
          </h6>
          <CustomButton
            // text={localQrData?.landing_btn_text}
            text={getTranslatedField(
              translatedData,
              localQrData,
              "landing_btn_text"
            )}
            url={localQrData?.landing_action_url}
            backgroundColor={localQrData?.color?.button}
            color={localQrData?.button_color}
          />
          <SocialMediaLinks
            socialLinks={localQrData?.landing_social}
            icons={icons}
          />
        </div>
      </div>
    </div>
  );
};
export const QRPreviewPdf = ({ localQrData }) => {
  const pdfFileUrl =
    localQrData?.pdf_file instanceof File
      ? URL.createObjectURL(localQrData.pdf_file)
      : localQrData?.pdf_file;

  const { translatedData } = useSelector((state) => state?.language);

  return (
    <div
      className="layout-content showBrowser "
      style={{
        backgroundColor: localQrData?.color?.background,
        width: "100%",
        maxWidth: "700px",
        margin: "0 auto",
      }}
    >
      <div className="website-companyName">
        <p
          style={{
            fontWeight: "700",
            wordBreak: "break-all",
            margin: "0",
            color: localQrData?.text_color,
            textAlign: "center",
          }}
        >
          {/* {localQrData?.pdf_company} */}
          {getTranslatedField(translatedData, localQrData, "pdf_company")}
        </p>
      </div>
      <div
        className="con-white"
        style={{
          background: "#fff",
          paddingTop: "10px",
          paddingBottom: "10px",
          marginTop: "8px",
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          alignItems: "center",
          paddingInline: "10px",
        }}
      >
        <p
          style={{
            fontWeight: "700",
            wordBreak: "break-all",
            color: localQrData?.text_color,
          }}
        >
          {/* {localQrData?.pdf_title} */}
          {getTranslatedField(translatedData, localQrData, "pdf_title")}
        </p>
        <h6
          style={{
            fontWeight: "400",
            wordBreak: "break-all",
            color: localQrData?.text_color,
            fontSize:"13px",
            lineHeight:"15px"
          }}
        >
          {/* {localQrData?.pdf_description} */}
          {getTranslatedField(translatedData, localQrData, "pdf_description")}
        </h6>
        <div
          style={{
            marginTop: "8px",
            marginBottom: "8px",
            width: "100%",
            maxWidth: "600px",
            height: "100%",
            aspectRatio: "1.6 / 1",
          }}
        >
          {pdfFileUrl ? (
            <iframe
              src={pdfFileUrl}
              width="100%"
              height="100%"
              style={{ border: "none", borderRadius: "4px" }}
              title="PDF Viewer"
            />
          ) : (
            <div
              style={{
                border: "1px solid #000",
                padding: "8px",
                width: "150px",
                height: "120px",
                borderRadius: "8px",
                marginInline: "auto",
              }}
            >
              <img
                src="/assets/images/default-img.png"
                width={100}
                height={100}
                style={{ width: "100%", height: "100%" }}
              />
            </div>
          )}
        </div>

        <CustomButton
          // text={"See Pdf"}
          text={"PDF"}
          url={pdfFileUrl}
          backgroundColor={localQrData?.color?.button}
          color={localQrData?.button_color}
          textColor= {localQrData?.text_color}
        />
      </div>
      <p
        style={{
          fontWeight: "600",
          wordBreak: "break-all",
          fontSize: "12px",
          marginTop: "12px",
          color: localQrData?.text_color,
          textAlign: "center",
        }}
      >
        {localQrData?.pdf_website}
      </p>
    </div>
  );
};

export const QRPreviewURL = ({ localQrData }) => {
  return (
    <div className="layout-content url ">
      {/* <img src="/assets/images/URLPreview.avif" alt="URLPreview" clas /> */}
      <img src="/assets/images/qr-icons/url.png" alt="url" />
    </div>
  );
};

const createVCardContent = ({ fullName, mobile, email, address, imageUrl }) => {
  const formattedAddress = address ? `;;${address};;;` : ";;;;";

  // If an image URL is provided, add it as a PHOTO property
  const photoProperty = imageUrl ? `PHOTO;VALUE=uri:${imageUrl}` : "";

  return `BEGIN:VCARD
VERSION:3.0
FN:${fullName || "No Name Provided"}
TEL;TYPE=CELL:${mobile || "No Phone Number Provided"}
EMAIL:${email || "No Email Provided"}
ADR;TYPE=HOME:${formattedAddress}
${photoProperty}
END:VCARD`;
};
export const QRPreviewVCard = ({ localQrData }) => {
  const { translatedData } = useSelector((state) => state?.language);

  const isReadyToDownload = localQrData?.vcard_full_name;

  const handleDownloadVCard = () => {
    const vCardContent = createVCardContent({
      fullName: localQrData?.vcard_full_name || "Default Name",
      mobile: localQrData?.vcard_landline_phone || "12345678",
      email: localQrData?.vcard_email || "default@example.com",
      address: localQrData?.vcard_address || "Default Address",
      imageUrl: localQrData?.vcard_image,
    });

    const blob = new Blob([vCardContent], { type: "text/vcf" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "vcard.vcf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const contentStyle = {
    backgroundColor: localQrData?.color?.background || "#fff",
    maxWidth: "400px",
    margin: "auto",
    padding: "12px",
    paddingBottom: "30px",
    borderRadius: "20px",
    fontFamily: "Poppins, sans-serif",
    color: localQrData?.text_color || "#333",
    boxShadow: "0 10px 25px rgba(0,0,0,0.1)",
    textAlign: "center",
  };

  const iconCircleStyle = {
    backgroundColor: "#f0f0f0",
    borderRadius: "50%",
    padding: "10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "40px",
    height: "40px",
  };

  const contactRowStyle = {
    display: "flex",
    alignItems: "flex-start",
    gap: "12px",
    marginBottom: "20px",
    textAlign: "left",
  };

  return (
    <div style={contentStyle} className="layout-content">
      {/* Image */}

      <DynamicImage
        data={localQrData}
        imageKey="vcard_image"
        altText="vcard Logo"
        style={{
          width: "100%",
          height: "120px",
          objectFit: "contain",
          marginBottom: "16px",
        }}
      />

      {/* Name */}
      <h2 style={{ fontSize: "22px", fontWeight: 700, marginBottom: "4px" }}>
        {getTranslatedField(translatedData, localQrData, "vcard_full_name")}
      </h2>

      {/* Profession */}
      {localQrData?.vcard_profession && (
        <p style={{ fontSize: "14px", marginBottom: "12px", color: "#777" }}>
          {getTranslatedField(translatedData, localQrData, "vcard_profession")}
        </p>
      )}

      {/* Add to Contact Button */}
      {isReadyToDownload && (
        <CustomButton
          text={
            getTranslatedField(translatedData, localQrData, "addToContact") ||
            "Add To Contact"
          }
          backgroundColor={localQrData?.color?.button}
          icon={<IoMdPersonAdd />}
          onClick={handleDownloadVCard}
          color={localQrData?.button_color}
        />
      )}

      <hr style={{ margin: "24px 0", borderColor: "#eee" }} />

      {/* Contact Information */}
      <div>
        {[
          {
            icon: <MdEmail />,
            label: "Email",
            value: localQrData?.vcard_email,
            type: "mailto",
          },
          {
            icon: <BsFillTelephoneFill />,
            label: "Mobile Phone",
            value: localQrData?.vcard_mobile_phone,
            type: "tel",
          },
          {
            icon: <BsFillTelephonePlusFill />,
            label: "Alternate Phone",
            value: localQrData?.vcard_landline_phone,
            type: "tel",
          },
          {
            icon: <FaFax />,
            label: "Fax",
            value: localQrData?.vcard_fax,
            type: "tel",
          },
          {
            icon: <FaLocationDot />,
            label: "Location",
            value: getTranslatedField(
              translatedData,
              localQrData,
              "vcard_address"
            ),
            type: "map",
          },
          {
            icon: <IoGlobeOutline />,
            label: "Website",
            value: localQrData?.vcard_website,
            type: "url",
          },
          {
            icon: <FaBuilding />,
            label: "Company",
            value: getTranslatedField(
              translatedData,
              localQrData,
              "vcard_company_name"
            ),
          },
        ].map(
          ({ icon, label, value, type }, index) =>
            value && (
              <div key={index} style={contactRowStyle}>
                <div style={iconCircleStyle}>{icon}</div>
                <div>
                  <p
                    style={{
                      margin: "0 0 2px",
                      fontSize: "12px",
                      color: "#888",
                    }}
                  >
                    {label}
                  </p>
                  <a
                    href={
                      type === "mailto"
                        ? `mailto:${value}`
                        : type === "tel"
                        ? `tel:${value}`
                        : type === "map"
                        ? `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                            value
                          )}`
                        : value
                    }
                    target={type === "url" ? "_blank" : undefined}
                    rel={type === "url" ? "noopener noreferrer" : undefined}
                    style={{
                      fontSize: "14px",
                      color: localQrData?.text_color,
                      textDecoration: "none",
                      wordBreak: "break-word",
                    }}
                  >
                    {value}
                  </a>
                </div>
              </div>
            )
        )}
      </div>

      {/* Summary */}
      {localQrData?.vcard_summary && (
        <div
          style={{
            marginTop: "24px",
            padding: "12px",
            backgroundColor: "#f9f9f9",
            borderRadius: "10px",
            fontSize: "13px",
            color: "#555",
            textAlign: "left",
            lineHeight: "15px",
          }}
        >
          {getTranslatedField(translatedData, localQrData, "vcard_summary")}
        </div>
      )}

      {/* Socials */}
      <div style={{ marginTop: "24px" }}>
        <SocialMediaLinks
          socialLinks={localQrData?.vcard_social}
          icons={icons}
        />
      </div>
    </div>
  );
};

export const QRPreviewBusiness = ({ localQrData }) => {
  // console.log("LocalDataBusiness", localQrData);
  const { translatedData } = useSelector((state) => state?.language);
  console.log("translatedDatatranslatedData", translatedData);

  return (
    <div
      className="layout-content showBrowser "
      style={{
        backgroundColor: localQrData?.color?.background,
        maxWidth: "700px",
        width: "100%",
        margin: "0 auto",
      }}
    >
      <div className="website-companyName">
        <p
          style={{
            fontWeight: "700",
            wordBreak: "break-all",
            color: localQrData?.text_color,
            textAlign: "center",
          }}
        >
          {/* {localQrData?.business_company} */}
          {getTranslatedField(translatedData, localQrData, "business_company")}
        </p>
      </div>
      <DynamicImage
        data={localQrData}
        imageKey="business_logo"
        altText="Company Logo"
        style={{
          width: "100%",
          height: "120px",
          objectFit: "contain",
          marginBottom: "16px",
        }}
      />

      {(localQrData?.business_title || localQrData?.business_subtitle) && (
        <div
          className="company-info"
          style={{
            backgroundColor: "#fff",
            width: "100%",
            padding: "16px",
            textAlign: "center",
            borderRadius: "8px",
            marginTop: "16px",
            marginBottom: "16px",
          }}
        >
          <h6 style={{ color: localQrData?.text_color }}>
            {/* {localQrData?.business_title} */}
            {getTranslatedField(translatedData, localQrData, "business_title")}
          </h6>
          <h6 style={{ color: localQrData?.text_color }}>
            {/* {localQrData?.business_subtitle} */}
            {getTranslatedField(
              translatedData,
              localQrData,
              "business_subtitle"
            )}
          </h6>
        </div>
      )}
      <CustomButton
        // text={localQrData?.business_btn_text}
        text={getTranslatedField(
          translatedData,
          localQrData,
          "business_btn_text"
        )}
        url={localQrData?.business_url}
        backgroundColor={localQrData?.color?.button}
        color={localQrData?.button_color}
      />

      {localQrData?.opening_hours_days &&
        Object.entries(localQrData?.opening_hours_days).some(
          ([day, schedule]) => schedule.enabled && schedule.times.length > 0
        ) && (
          <div
            className="opening-hour"
            style={{
              background: "#fff",
              width: "100%",
              padding: "8px",
              marginInline: "auto",
              borderRadius: "8px",
              marginTop: "16px",
              marginBottom: "16px",
            }}
          >
            <div
              className="top"
              style={{
                display: "flex",
                alignItems: "center",
                gap: "6px",
                marginBottom: "16px",
              }}
            >
              <GoClockFill size={20} />
              <h5
                style={{
                  margin: "0",
                  fontSize: "16px",
                  fontWeight: "700",
                  color: "#404040",
                }}
              >
                {/* Opening hours */}

                {getTranslatedField(
                  translatedData,
                  localQrData,
                  "openingHour"
                ) || "Opening Hours"}
              </h5>
            </div>

            {Object.entries(localQrData?.opening_hours_days).map(
              ([day, schedule]) =>
                schedule.enabled && (
                  <div
                    key={day}
                    style={{
                      marginBottom: "4px",
                      display: "flex",
                      justifyContent: "space-between",
                      fontSize: "12px",
                    }}
                  >
                    <strong>
                      {day.charAt(0).toUpperCase() + day.slice(1)}:
                    </strong>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      {schedule.times.length > 0 ? (
                        schedule.times.map((time, index) => (
                          <span key={index} style={{ color: "#8c8c8c" }}>
                            {time.start} - {time.end}
                          </span>
                        ))
                      ) : (
                        <span>
                          {" "}
                          {getTranslatedField(
                            translatedData,
                            localQrData,
                            "closed"
                          ) || "Closed"}
                        </span>
                      )}
                    </div>
                  </div>
                )
            )}
          </div>
        )}

      {(localQrData?.business_address ||
        localQrData?.business_numeration ||
        localQrData?.business_country ||
        localQrData?.business_state ||
        localQrData?.business_postalcode) && (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "start",
            gap: "10px",
            background: "#fff",
            width: "100%",
            padding: "16px",
            borderRadius: "8px",
            marginTop: "16px",
          }}
          className="location-con"
        >
          <div
            className="top"
            style={{
              display: "flex",
              alignItems: "center",
              gap: "6px",
            }}
          >
            <FaLocationDot size={20} />
            <h5
              style={{
                margin: "0",
                fontSize: "16px",
                fontWeight: "700",
                color: "#404040",
              }}
            >
              {getTranslatedField(translatedData, localQrData, "location") ||
                "Location"}
            </h5>
          </div>

          <div>
            <a
              href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                `${localQrData?.business_address} ${localQrData?.business_numeration}, ${localQrData?.business_country}, ${localQrData?.business_state}, ${localQrData?.business_postalcode}`
              )}`}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                textDecoration: "none",
                fontSize: "12px",
                color: localQrData?.text_color,
              }}
            >
              {localQrData?.business_address},{localQrData?.business_numeration}
              ,{localQrData?.business_country}, Zip Code:{" "}
              {localQrData?.business_postalcode}, {localQrData?.business_state}
            </a>
          </div>
        </div>
      )}

      {localQrData?.business_facilities &&
        Object.keys(localQrData.business_facilities).length > 0 && (
          <div
            className="facilities-con"
            style={{
              background: "#fff",
              padding: "16px",
              width: "100%",
              borderRadius: "8px",
              marginTop: "16px",
            }}
          >
            <h6>
              {" "}
              {getTranslatedField(translatedData, localQrData, "facilities") ||
                "Facilities"}
            </h6>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "6px",
                justifyContent: "center",
                flexWrap: "wrap",
              }}
            >
              {Object.entries(localQrData?.business_facilities).map(
                ([key, url]) => {
                  return <div key={key}>{FacilitiesIcon[key] || null}</div>;
                }
              )}
            </div>
          </div>
        )}

      {(localQrData?.business_name ||
        localQrData?.business_phone ||
        localQrData?.business_email ||
        localQrData?.business_website) && (
        <div
          className="contact-info"
          style={{
            background: "#fff",
            width: "100%",
            padding: "16px",
            borderRadius: "8px",
            marginTop: "16px",
          }}
        >
          <div
            className="top"
            style={{
              display: "flex",
              alignItems: "center",
              gap: "6px",
              marginBottom: "16px",
            }}
          >
            <FaBuilding size={20} />
            <h5
              style={{
                margin: "0",
                fontSize: "16px",
                fontWeight: "700",
                color: "#404040",
              }}
            >
              {getTranslatedField(translatedData, localQrData, "contactInfo") ||
                "Contact information"}
            </h5>
          </div>

          <div className="bottom">
            {localQrData?.business_name && (
              <div className="wrapp" style={{ marginBottom: "10px" }}>
                <p
                  style={{
                    color: "#8c8c8c",
                    fontSize: "12px",
                    margin: "0",
                  }}
                >
                  {getTranslatedField(translatedData, localQrData, "name") ||
                    "Name"}
                </p>
                <h6
                  style={{
                    fontSize: "12px",
                    margin: "0",
                    color: localQrData?.text_color,
                  }}
                >
                  {/* {localQrData?.business_name} */}
                  {getTranslatedField(
                    translatedData,
                    localQrData,
                    "business_name"
                  )}
                </h6>
              </div>
            )}

            {localQrData?.business_phone && (
              <div className="wrapp" style={{ marginBottom: "10px" }}>
                <p
                  style={{
                    color: "#8c8c8c",
                    fontSize: "12px",
                    margin: "0",
                    lineHeight: "12px",
                  }}
                >
                  {getTranslatedField(translatedData, localQrData, "phone") ||
                    "Phone"}
                </p>
                <a
                  href={`tel:${localQrData?.business_phone}`}
                  style={{
                    fontSize: "12px",
                    margin: "0",
                    textDecoration: "none",
                    color: localQrData?.text_color,
                  }}
                >
                  {localQrData?.business_phone}
                </a>
              </div>
            )}

            {localQrData?.business_email && (
              <div className="wrapp" style={{ marginBottom: "10px" }}>
                <p
                  style={{
                    color: "#8c8c8c",
                    fontSize: "12px",
                    margin: "0",
                    lineHeight: "8px",
                  }}
                >
                  {getTranslatedField(translatedData, localQrData, "email") ||
                    "Email"}
                </p>
                <a
                  href={`mailto:${localQrData?.business_email}`}
                  style={{
                    fontSize: "12px",
                    margin: "0",
                    textDecoration: "none",
                    color: localQrData?.text_color,
                  }}
                >
                  {localQrData?.business_email}
                </a>
              </div>
            )}

            {localQrData?.business_website && (
              <div className="wrapp" style={{ marginBottom: "10px" }}>
                <p
                  style={{
                    color: "#8c8c8c",
                    fontSize: "12px",
                    margin: "0",
                    lineHeight: "8px",
                  }}
                >
                  {getTranslatedField(translatedData, localQrData, "website") ||
                    "Website"}
                </p>
                <a
                  href={localQrData?.business_website}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    fontSize: "12px",
                    margin: "0",
                    textDecoration: "none",
                    color: localQrData?.text_color,
                  }}
                >
                  {localQrData?.business_website}
                </a>
              </div>
            )}
          </div>
        </div>
      )}

      {(localQrData?.business_description || localQrData?.business_about) && (
        <div
          className="about-company"
          style={{
            background: "#fff",
            width: "100%",
            padding: "16px",
            borderRadius: "8px",
            marginTop: "16px",
          }}
        >
          <h5>
            {" "}
            {getTranslatedField(translatedData, localQrData, "aboutCompany") ||
              "About Company"}
          </h5>
          <p
            style={{
              fontSize: "12px",
              color: "#8c8c8c",
              wordBreak: "break-all",
              color: localQrData?.text_color,
            }}
          >
            {/* {localQrData?.business_description || localQrData?.business_about} */}
            {getTranslatedField(
              translatedData,
              localQrData,
              "business_description"
            ) ||
              getTranslatedField(translatedData, localQrData, "business_about")}
          </p>
        </div>
      )}

      <SocialMediaLinks
        socialLinks={localQrData?.business_social}
        icons={icons}
      />
    </div>
  );
};

export const QRPreviewSocial = ({ localQrData }) => {
  const { translatedData } = useSelector((state) => state?.language);
  console.log("localQrData", localQrData);
  return (
    <div
      className="layout-content showBrowser "
      style={{ width: "100%", maxWidth: "700px", margin: "0 auto" }}
      // style={{ backgroundColor: localQrData?.color?.background }}
    >
      <div
        className="img-headline-con"
        style={{
          backgroundColor: localQrData?.color?.background,
          borderBottom: `3px solid ${localQrData?.color?.button}`,
          paddingTop: "10px",
          paddingInline: "8px",
          borderRadius:"6px 6px 0px 0px"
        }}
      >
        <DynamicImage
          data={localQrData}
          imageKey="social_logo"
          altText="Social Logo"
          style={{
            maxWidth: "100%",
            height: "120px",
            objectFit: "contain",
            marginBottom: "16px",
          }}
        />

        <p
          style={{
            fontWeight: "700",
            wordBreak: "break-all",
            margin: "0",
            color: localQrData?.text_color,
          }}
        >
          {/* {localQrData?.media_headline} */}
          {getTranslatedField(translatedData, localQrData, "media_headline")}
        </p>
        <p
          style={{
            fontWeight: "700",
            wordBreak: "break-all",
            margin: "0",
            color: localQrData?.text_color,
            fontSize:"13px",
            lineHeight:"15px"
          }}
        >
          {/* {localQrData?.media_description} */}
          {getTranslatedField(translatedData, localQrData, "media_description")}
        </p>
      </div>
      {/* <SocialMediaLinks socialLinks={localQrData?.media_social} icons={icons} /> */}

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          flexWrap: "wrap",
          gap: "12px",
          width: "100%",
          maxWidth: "700px",
          marginTop: "16px",
        }}
      >
        {Object.entries(localQrData?.media_social).map(([key, url]) => {
          return (
            <a
              key={key}
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                borderBottom: "1px solid #d9d9d9",
                paddingBottom: "8px",
                display: "flex",
                textDecoration: "none",
                alignItems: "center",
                gap: "8px",
                color: "#000",
              }}
            >
              {icons[key] || null}
              <p
                style={{
                  color: "#000",
                  fontWeight: "600",
                  margin: "0",
                  textTransform: "capitalize",
                }}
              >
                {key}
              </p>
            </a>
          );
        })}
      </div>
    </div>
  );
};
export const QRPreviewApps = ({ localQrData }) => {
  const { translatedData } = useSelector((state) => state?.language);

  return (
    <div
      className="layout-content showBrowser "
      style={{
        backgroundColor: localQrData?.color?.background,
        minHeight: "100%",
        width: "100%",
        maxWidth: "700px",
        margin: "0 auto",
      }}
    >
      {localQrData?.app_logo && (
        <div
          style={{
            backgroundColor: localQrData?.color?.button,
            height: "60px",
          }}
        />
      )}
      <DynamicImage
        data={localQrData}
        imageKey="app_logo"
        altText="App Logo"
        style={{
          // maxWidth: "300px",
          with: "100%",
          height: "120px",
          objectFit: "contain",
          marginTop: "-50px",
          marginBottom: "16px",
          borderRadius: "12px",
        }}
      />
      <p
        style={{
          fontWeight: "500",
          wordBreak: "break-all",
          color: localQrData?.text_color,
          textAlign: "center",
        }}
      >
        {/* {localQrData?.app_name} */}
        {getTranslatedField(translatedData, localQrData, "app_name")}
      </p>
      <p
        style={{
          fontWeight: "400",
          fontSize: "12px",
          wordBreak: "break-all",
          marginBottom: "8px",
          color: localQrData?.text_color,
          textAlign: "center",
        }}
      >
        {/* {localQrData?.app_company} */}
        {getTranslatedField(translatedData, localQrData, "app_company")}
      </p>
      {(localQrData?.app_description !== "" ||
        (localQrData?.app_social &&
          Object.keys(localQrData?.app_social).length > 0)) && (
        <div
          className="box"
          style={{
            background: localQrData?.color?.button,
            padding: "12px",
            width: "95%",
            marginInline: "auto",
            borderRadius: "8px",
          }}
        >
          <p
            style={{
              fontWeight: "500",
              wordBreak: "break-all",
              margin: "0",
              color: localQrData?.text_color,
              textAlign: "center",
              fontSize:"13px",
              lineHeight:"15px"
            }}
          >
            {/* {localQrData?.app_description} */}
            {getTranslatedField(translatedData, localQrData, "app_description")}
          </p>

          <SocialMediaLinks
            socialLinks={localQrData?.app_social}
            icons={iconsApps}
          />
        </div>
      )}
      <div
        style={{
          paddingTop: "16px",
          paddingBottom: "50px",
          paddingRight: "10px",
          textAlign: "center",
        }}
      >
        <a
          style={{
            fontWeight: "500",
            wordBreak: "break-all",
            textDecoration: "none",
            cursor: "pointer",
            color: localQrData?.text_color,
          }}
          href={localQrData?.app_website}
          target="_blank"
          rel="noopener"
        >
          {localQrData?.app_website}
        </a>
      </div>
    </div>
  );
};

// export const QRPreviewVideo = ({ localQrData }) => {
//   const videoUrl =
//     localQrData?.video_path instanceof File
//       ? URL.createObjectURL(localQrData.video_path)
//       : typeof localQrData?.video_path === "string" &&
//         localQrData?.video_path.trim() !== ""
//       ? localQrData.video_path
//       : null;

//   return (
//     <div
//       className="layout-content showBrowser "
//       style={{
//         backgroundColor: localQrData?.color?.background,
//         minHeight: "100%",
//         left: "0px",
//       }}
//     >
//       <h4
//         style={{
//           fontWeight: "700",
//           wordBreak: "break-all",
//           marginBottom: "8px",
//           fontSize: "16px",
//         }}
//       >
//         {localQrData?.video_name}
//       </h4>
//       <h5
//         style={{
//           fontWeight: "500",
//           wordBreak: "break-all",
//           marginBottom: "8px",
//           fontSize: "14px",
//         }}
//       >
//         {localQrData?.video_title}
//       </h5>
//       <h6
//         style={{
//           fontWeight: "400",
//           wordBreak: "break-all",
//           marginBottom: "16px",
//           fontSize: "13px",
//         }}
//       >
//         {localQrData?.video_description}
//       </h6>

//       <CustomButton
//         text={localQrData?.video_button}
//         url={localQrData?.video_url}
//         backgroundColor={localQrData?.color?.button}
//       />
//       {localQrData?.video_path && (
//         <div
//           style={{
//             width: "90%",
//             maxWidth: "300px",
//             height: "auto",
//             aspectRatio: "16 / 9",
//             marginInline: "auto",
//             marginBottom: "20px",
//             position: "relative",
//             background: "#f2f2f2",
//             marginTop: "16px",
//           }}
//         >
//           <video
//             src={videoUrl || localQrData?.video_path}
//             style={{
//               width: "100%",
//               height: "100%",
//               borderRadius: "4px",
//               position: "absolute",
//               top: 0,
//               left: 0,
//               padding: "10px",
//             }}
//             controls
//           />
//         </div>
//       )}

//       <div
//         style={{
//           background: "#fff",
//           borderRadius: "8px",
//           marginTop: "16px",
//         }}
//       >
//         <SocialMediaLinks
//           socialLinks={localQrData?.video_social}
//           icons={icons}
//         />
//       </div>
//     </div>
//   );
// };

// USED QRPreviewVideo in mobileFrame
export const QRPreviewVideo = ({ localQrData }) => {
  // Check if specific fields are empty to decide how to display the video

  const hasDetails =
    localQrData?.video_name ||
    (localQrData?.video_title && localQrData.video_title !== "undefined") ||
    (localQrData?.video_social &&
      Object.keys(localQrData.video_social).length > 0);

  const videoUrl =
    (localQrData?.video_path || localQrData?.video) instanceof File
      ? URL.createObjectURL(localQrData.video_path || localQrData?.video)
      : typeof localQrData?.video_path === "string" &&
        localQrData?.video_path.trim() !== ""
      ? localQrData.video_path
      : null;
  // console.log("videoURL", localQrData?.video);

  return (
    <div
      className="layout-content showBrowser"
      style={{
        backgroundColor: localQrData?.color?.background,
        // minHeight: hasDetails ?  "100%" : "97%",
        minHeight: "100%",
        left: "0px",
        paddingBottom: "20px",
        paddingTop: hasDetails ? "3.875rem" : "20px",
      }}
    >
      {/* Always show video and handle full screen or limited height based on details */}
      {videoUrl && (
        <div
          style={{
            width: "100%",
            height: hasDetails ? "250px" : "100%",
            aspectRatio: "16 / 9",
            marginInline: "auto",
            position: "relative",
            background: "#000",
            marginBottom: hasDetails ? "20px" : "0",
          }}
        >
          <video
            src={videoUrl}
            style={{
              width: "100%",
              height: "100%",
              borderRadius: "4px",
              position: "absolute",
              top: 0,
              left: 0,
            }}
            controls
          />
        </div>
      )}

      {hasDetails && (
        <>
          <h4
            style={{
              fontWeight: "700",
              wordBreak: "break-all",
              marginBottom: "8px",
              fontSize: "16px",
              color: localQrData?.text_color,
            }}
          >
            {localQrData?.video_name}
          </h4>
          <h5
            style={{
              fontWeight: "500",
              wordBreak: "break-all",
              marginBottom: "8px",
              fontSize: "14px",
              color: localQrData?.text_color,
            }}
          >
            {localQrData?.video_title}
          </h5>
          <h6
            style={{
              fontWeight: "400",
              wordBreak: "break-all",
              marginBottom: "16px",
              fontSize: "13px",
              color: localQrData?.text_color,
            }}
          >
            {localQrData?.video_description}
          </h6>

          <CustomButton
            text={localQrData?.video_button}
            url={localQrData?.video_url}
            backgroundColor={localQrData?.color?.button}
            color={localQrData?.button_color}
          />
          {localQrData?.video_social &&
            Object.keys(localQrData.video_social).length > 0 && (
              <div
                style={{
                  background: "#fff",
                  borderRadius: "8px",
                  marginTop: "8px",
                }}
              >
                <SocialMediaLinks
                  socialLinks={localQrData?.video_social}
                  icons={icons}
                />
              </div>
            )}
        </>
      )}
    </div>
  );
};

export const QRPreviewLinks = ({ localQrData }) => {
  // console.log("localQrDataLink", localQrData);
  const { translatedData } = useSelector((state) => state?.language);
  return (
    <div
      className="layout-content showBrowser "
      style={{
        backgroundColor: localQrData?.color?.background,
        minHeight: "100%",
        left: "0px",
        width: "100%",
        maxWidth: "700px",
        margin: "0 auto",
      }}
    >
      <DynamicImage
        data={localQrData}
        imageKey="linkslogo"
        altText="Link Logo"
        style={{ width: "100%", height: "120px", objectFit: "contain" }}
      />
      <p
        style={{
          fontWeight: "600",
          wordBreak: "break-all",
          marginTop: "16px",
          color: localQrData?.text_color,
          textAlign: "center",
        }}
      >
        {/* {localQrData?.links_title} */}
        {getTranslatedField(translatedData, localQrData, "links_title")}
      </p>
      <h6
        style={{
          fontWeight: "400",
          wordBreak: "break-all",
          marginTop: "16px",
          color: localQrData?.text_color,
          textAlign: "center",
           fontSize:"13px",
            lineHeight:"15px"
        }}
      >
        {/* {localQrData?.links_description} */}
        {getTranslatedField(translatedData, localQrData, "links_description")}
      </h6>

      <div
        className="linkbox-con"
        style={{
          width: "100%",
          maxWidth: "700px",
          display: "flex",
          gap: "12px",
          flexDirection: "column",
        }}
      >
        {localQrData?.all_links?.map((link, index) => {
          const imageUrl =
            link.image instanceof File
              ? URL.createObjectURL(link.image)
              : link.image;
          return (
            <Link
              key={index}
              className="linkbox"
              style={{
                background: localQrData?.color?.button,
                width: "100%",
                display: "flex",
                justifyContent: "start",
                alignItems: "center",
                padding: "12px",
                borderRadius: "6px",
                color: "#fff",
                textDecoration: "none",
                gap: "12px",
              }}
              to={link?.url}
              target="_blank"
            >
              {link?.image && (
                <img
                  src={imageUrl}
                  alt={link.text}
                  style={{ width: "28px", height: "28px", borderRadius: "6px" }}
                />
              )}
              {/* {console.log("link?.link_image", link)} */}
              {/* Optional: Set image size */}
              <h6 style={{ margin: "0", color: localQrData?.text_color }}>
                {link?.text}
              </h6>
            </Link>
          );
        })}
      </div>

      <SocialMediaLinks socialLinks={localQrData?.links_social} icons={icons} />
    </div>
  );
};

{
  /* <Swiper
            effect={"cards"}
            grabCursor={true}
            modules={[EffectCards]}
            className="mySwiper"
          >
            {images.map((imgUrl, index) => (
              <SwiperSlide key={index}>
                <img
                  src={imgUrl}
                  alt={`Gallery Image ${index + 1}`}
                  style={{
                    width: "80%",
                    borderRadius: "8px",
                    height: "160px",

                    marginTop: "10px",
                    objectFit: "contain",
                    borderRadius: "8px",
                  }}
                />
              </SwiperSlide>
            ))}
          </Swiper> */
}

// export const QRPreviewGallery = ({ localQrData }) => {
//   const images = Array.isArray(localQrData?.gallery_image)
//     ? localQrData.gallery_image.map((image) =>
//         image instanceof File ? URL.createObjectURL(image) : image
//       )
//     : [];

//   return (
//     <div
//       className="layout-content showBrowser "
//       style={{
//         backgroundColor: localQrData?.color?.background,
//         left: "3px",
//         paddingTop: "30px",
//         overflowX: "hidden",
//       }}
//     >
//       <p
//         style={{
//           fontWeight: "600",
//           wordBreak: "break-all",
//           marginTop: "16px",
//         }}
//       >
//         {localQrData?.gallery_title}
//       </p>
//       <h6
//         style={{
//           fontWeight: "400",
//           wordBreak: "break-all",
//           marginTop: "16px",
//         }}
//       >
//         {localQrData?.gallery_description}
//       </h6>

//       {images.length > 0 && (
//         <div
//           style={{
//             backgroundColor: localQrData?.color?.button,
//             height: "200px",
//             marginBottom: "16px",
//           }}
//         >
//           {images.map((imgUrl, index) => (
//             <img
//               src={imgUrl}
//               alt={`Gallery Image ${index + 1}`}
//               style={{
//                 width: "80%",
//                 borderRadius: "8px",
//                 height: "160px",

//                 marginTop: "10px",
//                 objectFit: "contain",
//                 borderRadius: "8px",
//               }}
//             />
//           ))}

//         </div>
//       )}

//       <CustomButton
//         text={localQrData?.gallery_btn_text}
//         url={localQrData?.gallery_url}
//         backgroundColor={localQrData?.color?.button}
//       />
//       <div style={{ paddingTop: "16px", paddingBottom: "50px" }}>
//         <a
//           style={{
//             fontWeight: "500",
//             wordBreak: "break-all",
//             textDecoration: "none",
//             cursor: "pointer",
//             color: "#000",
//           }}
//           href={localQrData?.gallery_website}
//           target="_blank"
//         >
//           {localQrData?.gallery_website}
//         </a>
//       </div>
//     </div>
//   );
// };

// export const QRPreviewGallery = ({ localQrData }) => {
//   const images = Array.isArray(localQrData?.gallery_image)
//     ? localQrData.gallery_image.map((image) =>
//         image instanceof File ? URL.createObjectURL(image) : image
//       )
//     : [];

//   const hasContent =
//     !!localQrData?.gallery_title || !!localQrData?.gallery_description;

//   return (
//     <div
//       className="layout-content showBrowser"
//       style={{
//         backgroundColor: localQrData?.color?.background,
//         minHeight: "100%",
//         left: "0px",
//         paddingBottom: "20px",
//         // paddingTop: hasContent ? "3.875rem" : "20px",
//         paddingBottom: "0px",
//         padding: "0px",
//         width: "100%",maxWidth:"700px",
//         margin: "0 auto",
//       }}
//     >
//       {images.map((imgUrl, index) => (
//         <div
//           key={index}
//           style={{
//             width: "100%",
//             // height: hasContent ? "40%" : "100%",
//             aspectRatio: "16 / 9",
//             marginInline: "auto",
//             position: "relative",
//             // marginBottom: hasContent ? "12px" : "0",
//             marginTop: index + 1 ? "4px" : "",
//             height: "100%",
//             display:"flex",
//             justifyContent:"center",
//             alignItems:"center"

//           }}
//         >
//           <img
//             src={imgUrl}
//             alt={`Gallery Image ${index + 1}`}
//             style={{
//               // height:  hasContent ? "40%" : "100%",
//               objectFit: "cover",
//               height: "100%",
//               width:"96%",
//               borderRadius:"6px"
//             }}
//           />
//         </div>
//       ))}
//       {hasContent && (
//         <div
//           style={{
//             padding: "20px",
//             paddingBottom: "20px",
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//             flexDirection: "column",
//             minHeight: "50%",
//           }}
//         >
//           <p
//             style={{
//               fontWeight: "600",
//               wordBreak: "break-all",
//               marginTop: "16px",
//               color: localQrData?.text_color,
//             }}
//           >
//             {localQrData?.gallery_title}
//           </p>
//           <h6
//             style={{
//               fontWeight: "400",
//               wordBreak: "break-all",
//               marginTop: "16px",
//               color: localQrData?.text_color,
//             }}
//           >
//             {localQrData?.gallery_description}
//           </h6>
//           <CustomButton
//             text={localQrData?.gallery_btn_text}
//             url={localQrData?.gallery_url}
//             backgroundColor={localQrData?.color?.button}
//             color={localQrData?.button_color}
//           />
//           <a
//             style={{
//               fontWeight: "500",
//               wordBreak: "break-all",
//               textDecoration: "none",
//               cursor: "pointer",
//               color: localQrData?.text_color,
//               marginTop: "16px",
//             }}
//             href={localQrData?.gallery_website}
//             target="_blank"
//           >
//             {localQrData?.gallery_website}
//           </a>
//         </div>
//       )}
//     </div>
//   );
// };

export const QRPreviewGallery = ({ localQrData }) => {
  const { translatedData } = useSelector((state) => state?.language);
  const images = Array.isArray(localQrData?.gallery_image)
    ? localQrData.gallery_image.map((image) =>
        image instanceof File ? URL.createObjectURL(image) : image
      )
    : [];

  const hasContent =
    !!localQrData?.gallery_title ||
    !!localQrData?.gallery_description ||
    !!localQrData?.gallery_btn_text ||
    !!localQrData?.gallery_website ||
    localQrData?.gallery_url;

  return (
    <div
      className="layout-content showBrowser"
      style={{
        backgroundColor: localQrData?.color?.background,
        minHeight: "100%",
        width: "100%",
        maxWidth: "700px",
        margin: "0 auto",
        padding: "0px",
        textAlign: "center",
      }}
    >
      {images.map((imgUrl, index) => (
        <div
          key={index}
          style={{
            // display: "flex",
            // flexDirection: "column",
            width: "100%",
            height: "93%",
            marginTop: index === 0 ? "4px" : "",
            marginBottom: "10px",
          }}
        >
          {index === 0 && hasContent ? (
            <>
              <div
                style={{
                  width: "100%",
                  height: "50%",
                }}
              >
                <img
                  src={imgUrl}
                  alt={`Gallery Image ${index + 1}`}
                  style={{
                    objectFit: "cover",
                    height: "100%",
                    width: "96%",
                    borderRadius: "6px",
                  }}
                />
              </div>
              <div
                style={{
                  padding: "20px",
                  height: "50%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                }}
              >
                <p
                  style={{
                    fontWeight: "600",
                    wordBreak: "break-all",
                    marginTop: "16px",
                    color: localQrData?.text_color,
                    marginBottom:"0px"
                  }}
                >
                  {/* {localQrData?.gallery_title} */}
                  {getTranslatedField(
                    translatedData,
                    localQrData,
                    "gallery_title"
                  )}
                </p>
                <h6
                  style={{
                    fontWeight: "400",
                    wordBreak: "break-all",
                    color: localQrData?.text_color,
                       fontSize:"13px",
            lineHeight:"15px"
                  }}
                >
                  {/* {localQrData?.gallery_description} */}
                  {getTranslatedField(
                    translatedData,
                    localQrData,
                    "gallery_description"
                  )}
                </h6>
                <CustomButton
                  // text={localQrData?.gallery_btn_text}
                  text={getTranslatedField(
                    translatedData,
                    localQrData,
                    "gallery_btn_text"
                  )}
                  url={localQrData?.gallery_url}
                  backgroundColor={localQrData?.color?.button}
                  color={localQrData?.button_color}
                />
                <a
                  style={{
                    fontWeight: "500",
                    wordBreak: "break-all",
                    textDecoration: "none",
                    cursor: "pointer",
                    color: localQrData?.text_color,
                    marginTop: "16px",
                  }}
                  href={localQrData?.gallery_website}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {localQrData?.gallery_website}
                </a>
              </div>
            </>
          ) : (
            <div
              style={{
                width: "100%",
                height: "100%",
                paddingBottom: "45px",
                textAlign: "center",
              }}
            >
              <img
                src={imgUrl}
                alt={`Gallery Image ${index + 1}`}
                style={{
                  objectFit: "cover",
                  height: "100%",
                  width: "96%",
                  borderRadius: "6px",
                }}
              />
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export const QRPreviewYoutube = ({ localQrData }) => {
  // Extract videoId from youtube_url
  const videoId = localQrData?.youtube_url.split("v=")[1]?.split("&")[0];
  const embedUrl = `https://www.youtube.com/embed/${videoId}`;
  const watchUrl = `https://www.youtube.com/watch?v=${videoId}`;

  // State to track embedding error
  const [embedError, setEmbedError] = React.useState(false);

  const handleEmbedError = () => {
    console.error("Embedding is restricted for this video.");
    setEmbedError(true); // Set error state to show fallback link
  };

  return (
    <div
      className="layout-content showBrowser"
      style={{
        left: "0",
      }}
    >
      {localQrData?.youtube_url ? (
        <div
          style={{
            width: "95%",
            position: "relative",
            paddingBottom: "50%",
            height: "200px",
            marginTop: "80px",
            marginInline: "auto",
          }}
        >
          {!embedError ? (
            <iframe
              src={embedUrl}
              frameBorder="0"
              allowFullScreen
              title="YouTube Video"
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                borderRadius: "4px",
              }}
              onError={handleEmbedError}
            ></iframe>
          ) : (
            <div>
              <p>
                This video cannot be embedded. You can watch it directly on
                YouTube:
              </p>
              <a
                href={watchUrl}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "blue", textDecoration: "underline" }}
              >
                Watch on YouTube
              </a>
            </div>
          )}
        </div>
      ) : null}
    </div>
  );
};

export const QRPreviewEvent = ({ localQrData }) => {
  console.log("localQrDataEvent", localQrData);
  const { translatedData } = useSelector((state) => state?.language);
  const [isDropdownOpen, setDropdownOpen] = useState(false);

  const toggleDropdown = () => {
    setDropdownOpen(!isDropdownOpen);
  };

  const calendarUrls = {
    iCal: `https://calendar.google.com/calendar/r/eventedit?text=${encodeURIComponent(
      localQrData?.event_title
    )}&dates=${localQrData?.event_time_start}/${
      localQrData?.event_time_end
    }&details=${encodeURIComponent(
      localQrData?.event_description
    )}&location=${encodeURIComponent(localQrData?.event_location_address)}`,
    Google: `https://calendar.google.com/calendar/r/eventedit?text=${encodeURIComponent(
      localQrData?.event_title
    )}&dates=${localQrData?.event_time_start}/${
      localQrData?.event_time_end
    }&details=${encodeURIComponent(
      localQrData?.event_description
    )}&location=${encodeURIComponent(localQrData?.event_location_address)}`,
    Outlook: `https://outlook.live.com/owa/?path=/calendar/action/compose&subject=${encodeURIComponent(
      localQrData?.event_title
    )}&startdt=${localQrData?.event_time_start}&enddt=${
      localQrData?.event_time_end
    }&body=${encodeURIComponent(
      localQrData?.event_description
    )}&location=${encodeURIComponent(localQrData?.event_location_address)}`,
    Yahoo: `https://calendar.yahoo.com/?v=60&view=d&type=20&title=${encodeURIComponent(
      localQrData?.event_title
    )}&st=${localQrData?.event_time_start}&et=${
      localQrData?.event_time_end
    }&desc=${encodeURIComponent(
      localQrData?.event_description
    )}&in_loc=${encodeURIComponent(localQrData?.event_location_address)}`,
  };

  return (
    <div
      className="layout-content showBrowser "
      style={{
        backgroundColor: localQrData?.color?.background,
        // left: "3px",
        overflowX: "hidden",
        width: "100%",
        maxWidth: "700px",
        margin: "0 auto",
      }}
    >
      <DynamicImage
        data={localQrData}
        imageKey="event_image"
        altText="Event Logo"
        style={{
          width: "100%",
          objectFit: "contain",
          height: "130px",
          borderRadius: "6px",
          objectPosition: "center",
        }}
      />
      {(localQrData?.event_title || localQrData?.event_description) && (
        <div
          className="whiteBox"
          style={{
            background: "#fff",
            paddingBottom: "22px",
            marginTop: "-16px",
            paddingTop: "22px",
            borderRadius:"6px",
            paddingInline:"6px",
          }}
        >
          <p
            style={{
              fontWeight: "700",
              wordBreak: "break-all",
              color: localQrData?.text_color,
              textAlign: "center",
            }}
          >
            {/* {localQrData?.event_title} */}
            {getTranslatedField(translatedData, localQrData, "event_title")}
          </p>
          <h6
            style={{
              fontWeight: "400",
              wordBreak: "break-all",
              marginTop: "16px",
              color: localQrData?.text_color,
              textAlign: "center",
              fontSize:"12px",
              lineHeight:"14px"
            }}
          >
            {/* {localQrData?.event_description} */}
            {getTranslatedField(
              translatedData,
              localQrData,
              "event_description"
            )}
          </h6>
          <CustomButton
            // text={localQrData?.event_btn_text}
            text={getTranslatedField(
              translatedData,
              localQrData,
              "event_btn_text"
            )}
            url={localQrData?.event_action_url}
            backgroundColor={localQrData?.color?.button}
            color={localQrData?.button_color}
          />
        </div>
      )}

      {localQrData?.event_time_start && (
        <div
          className="box"
          style={{
            background: "#fff",
            width: "100%",
            maxWidth: "700px",
            padding: "12px",
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            gap: "12px",
            marginTop: "16px",
            borderRadius:"6px"
          }}
        >
          <div
            className="top"
            style={{ display: "flex", alignItems: "center", gap: "6px" }}
          >
            <GoClockFill />
            <h5 style={{ margin: "0", fontSize: "16px", fontWeight: "600" }}>
              {getTranslatedField(translatedData, localQrData, "dateOfEvent") ||
                "Date of the event"}
            </h5>
          </div>
          <div
            className="wrap"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <h6 style={{ margin: "0px", color: "#8c8c8c", fontSize: "12px" }}>
              {getTranslatedField(translatedData, localQrData, "start") ||
                "start"}
            </h6>
            <h6 style={{ margin: "0px", color: "#000", fontSize: "12px" }}>
              {localQrData?.event_time_start
                ? formatDate(localQrData?.event_time_start)
                : ""}
            </h6>
          </div>
          <div
            className="wrap"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <h6 style={{ margin: "0px", color: "#8c8c8c", fontSize: "12px" }}>
              {getTranslatedField(translatedData, localQrData, "end") || "End"}
            </h6>
            <h6 style={{ margin: "0px", color: "#000", fontSize: "12px" }}>
              {localQrData?.event_time_end
                ? formatDate(localQrData?.event_time_end)
                : ""}
            </h6>
          </div>
     {(localQrData?.scheduleTimeStart || localQrData?.scheduleTimeEnd)  &&   <div
            className="wrap"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <h6 style={{ margin: "0px", color: "#8c8c8c", fontSize: "12px" }}>
              {getTranslatedField(translatedData, localQrData, "Schedule") || "Schedule"}
            </h6>
            <h6 style={{ margin: "0px", color: "#000", fontSize: "12px" }}>
              {localQrData?.scheduleTimeStart + " - " + localQrData?.scheduleTimeEnd
             }
            </h6>
          </div>}

          {localQrData?.event_time_action_title && (
            <div style={{ position: "relative", display: "flex" }}>
              <button
                onClick={toggleDropdown}
                style={{
                  background: localQrData?.color?.button,
                  height: "38px",
                  borderRadius: "8px",
                  outline: "none",
                  border: "none",
                  color: "#fff",
                  width: "240px",
                  marginInline: "auto",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px",
                  cursor: "pointer",
                }}
              >
                <CiCalendar size={22} />
                {/* Add to Calendar */}
                {/* {localQrData?.event_time_action_title} */}
                {getTranslatedField(
                  translatedData,
                  localQrData,
                  "event_time_action_title"
                )}
              </button>
              {isDropdownOpen && (
                <div
                  style={{
                    position: "absolute",
                    top: "100%",
                    left: "50%",
                    transform: "translateX(-50%)",
                    background: "#fff",
                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                    borderRadius: "8px",
                    overflow: "hidden",
                    zIndex: 10,
                    width: "200px",
                  }}
                >
                  {Object.keys(calendarUrls).map((key) => (
                    <a
                      key={key}
                      href={calendarUrls[key]}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        padding: "6px 14px",
                        color: "#333",
                        textDecoration: "none",
                        fontSize: "16px",
                      }}
                      onMouseEnter={(e) =>
                        (e.currentTarget.style.background = "#f0f0f0")
                      }
                      onMouseLeave={(e) =>
                        (e.currentTarget.style.background = "transparent")
                      }
                    >
                      {key === "Google" && (
                        <FaGoogle style={{ marginRight: "8px" }} />
                      )}
                      {key === "iCal" && (
                        <FaCalendarAlt style={{ marginRight: "8px" }} />
                      )}
                      {key === "Outlook" && (
                        <FaCalendarPlus style={{ marginRight: "8px" }} />
                      )}
                      {key === "Yahoo" && (
                        <FaYahoo style={{ marginRight: "8px" }} />
                      )}
                      {key}
                    </a>
                  ))}
                </div>
              )}
            </div>
          )}
        </div>
      )}


 
      {(localQrData?.event_location_address ||
        localQrData?.event_location_numeration ||
        localQrData?.event_location_country ||
        localQrData?.event_location_postal_code ||
        localQrData?.event_location_city ||
        localQrData?.event_location_state) && (
        <div
          className="box"
          style={{
            background: "#fff",
            width: "100%",
            maxWidth: "700px",
            padding: "6px",
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            gap: "12px",
            marginTop: "16px",
            wordBreak: "break-all",
            alignItems: "start",
            borderRadius:"4px"
          }}
        >
          <div
            className="top"
            style={{ display: "flex", alignItems: "center", gap: "6px" }}
          >
            <FaLocationDot />

            <p
              style={{
                margin: "0",
                color: "#000",
                fontWeight: "600",
                fontSize: "16px",
                lineHeight: "8px",
              }}
            >
              {getTranslatedField(translatedData, localQrData, "location") ||
                "Location"}
            </p>
          </div>
          <a
            href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
              `${localQrData?.event_location_address} ${localQrData?.event_location_numeration}, ${localQrData?.event_location_country}, ${localQrData?.event_location_state}, ${localQrData?.event_location_postal_code}`
            )}`}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              textDecoration: "none",
              fontSize: "12px",
              color: localQrData?.text_color,
            }}
          >
            {/* {localQrData?.event_location_address}, */}
            {getTranslatedField(
              translatedData,
              localQrData,
              "event_location_address"
            )}
            {localQrData?.event_location_numeration},{" "}
            {/* {localQrData?.event_location_country} */}
            {getTranslatedField(
              translatedData,
              localQrData,
              "event_location_country"
            )}
            ,{" "}
                {getTranslatedField(
              translatedData,
              localQrData,
              "event_location_city"
            )},{" "}
            {getTranslatedField(translatedData, localQrData, "zipCode") ||
              "Zip Code"}
            : {localQrData?.event_location_postal_code},
            {localQrData?.event_location_state},{" "}
          </a>
        </div>
      )}

      {(localQrData?.event_organizer_name ||
        localQrData?.event_organizer_phone ||
        localQrData?.event_organizer_email ||
        localQrData?.event_organizer_aboutx) && (
        <div
          className="box"
          style={{
            background: "#fff",
            maxWidth: "700px",
            width: "100%",
            padding: "16px",
            display: "flex",
            flexDirection: "column",
            alignItems: "start",
            gap: "2px",
            padding: "8px",
            marginTop: "16px",
            borderRadius:"6px"
          }}
        >
          <div
            className="top"
            style={{
              display: "flex",
              alignItems: "center",
              gap: "6px",
              paddingBottom: "8px",
            }}
          >
            <IoPeopleCircle size={24} />
            <h5 style={{ margin: "0", fontSize: "16px", fontWeight: "700" }}>
              {getTranslatedField(
                translatedData,
                localQrData,
                "organizerInfo"
              ) || "Organizer information"}
            </h5>
          </div>

          <div
            className="wrap"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "start",
              gap: "4px",
            }}
          >
            <p style={{ margin: "0", color: "#8c8c8c", margin: "0px" }}>
              {" "}
              {getTranslatedField(translatedData, localQrData, "name") ||
                "Name"}
            </p>
            <h6 style={{ fontSize: "12px", color: localQrData?.text_color }}>
              {/* {localQrData?.event_organizer_name} */}
              {getTranslatedField(
                translatedData,
                localQrData,
                "event_organizer_name"
              )}
            </h6>
          </div>

          <div
            className="wrap"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "start",
              gap: "4px",
            }}
          >
            <p style={{ margin: "0", color: "#8c8c8c" }}>
              {getTranslatedField(translatedData, localQrData, "phone") ||
                "Phone"}
            </p>

            <h6
              style={{
                fontSize: "12px",
                margin: "0px",
                color: localQrData?.text_color,
              }}
            >
              {localQrData?.event_organizer_phone}
            </h6>
          </div>

          <div
            className="wrap"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "start",
              gap: "4px",
            }}
          >
            <p style={{ margin: "0", color: "#8c8c8c" }}>
              {getTranslatedField(translatedData, localQrData, "email") ||
                "Email"}
            </p>

            <a
              href={`mailto:${localQrData?.event_organizer_email}`}
              style={{
                textDecoration: "none",
                fontSize: "12px",
                color: localQrData?.text_color,
                marginBottom: "8px",
              }}
            >
              {localQrData?.event_organizer_email}
            </a>
          </div>

          <div
            className="wrap"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "start",
              gap: "4px",
            }}
          >
            <p style={{ margin: "0", color: "#8c8c8c" }}>
              {getTranslatedField(translatedData, localQrData, "website") ||
                "Website"}
            </p>
            <a
              href={localQrData?.event_organizer_website}
              style={{
                textDecoration: "none",
                fontSize: "12px",
                color: localQrData?.text_color,
                marginBottom: "8px",
              }}
            >
              {localQrData?.event_organizer_website}
            </a>
          </div>
          <div
            className="wrap"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "start",
              gap: "4px",
            }}
          >
            <p style={{ margin: "0", color: "#8c8c8c" }}>
              {getTranslatedField(translatedData, localQrData, "about") ||
                "About"}
            </p>

            <h6
              style={{
                fontSize: "12px",
                marginBottom: "8px",
                color: localQrData?.text_color,
              }}
            >
              {/* {localQrData?.event_organizer_about} */}
              {getTranslatedField(
                translatedData,
                localQrData,
                "event_organizer_about"
              )}
            </h6>
          </div>
        </div>
      )}

      {localQrData?.event_facilities && (
        <div
          className="box-facilities"
          style={{ background: "#fff", padding: "8px", marginTop: "16px" }}
        >
          <FacilitiesIconComp
            socialLinks={localQrData?.event_facilities}
            icons={FacilitiesIcon}
          />
        </div>
      )}
    </div>
  );
};

// ELABELS

const ReviewFormSubmit = ({ questions, qrCodeObj }) => {
  // console.log("questions", questions);
  const [rating, setRating] = useState(null);
  // console.log("qrCodeObj", qrCodeObj);

  const {
    control,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm();

  //API FOR REVIEW FORM SUBMIT
  const { mutate: mutateReview, isPending: isLoading } = useMutation({
    mutationFn: apis.PostReviews,
    onError: function (error) {
      // console.log("error", error);
      toast.error("An error occurred while submitting your review.");
    },
    onSuccess: ({ data: reviewSubmitSuccess, status }) => {
      // console.log("reviewSubmitSuccess!!:", reviewSubmitSuccess);
      toast.success(
        "Your review has been successfully submitted! Thank you for your feedback."
      );
      questions.forEach((_, index) => {
        setValue(`question-${index}`, "");
      });
      // console.log("Form State after reset:", control._formValues);
    },
  });

  const onSubmit = (data) => {
    // console.log(data, "formloggg");

    const payload = Object.entries(data).map(([key, value]) => {
      const questionIndex = key.split("-")[1];
      const questionId = questions[questionIndex]?.id;

      return {
        question_id: questionId,
        answer: value,
      };
    });

    // console.log("Payload to be sent:", payload);

    // payload.forEach((payload) => {
    mutateReview(payload);
    // });
  };

  //API FOR REVIEW RATING STAR
  const { mutate: mutateReviewRating, isPending: isLoadingRating } =
    useMutation({
      mutationFn: apis.PostReviewsRating,
      onError: function (error) {
        // console.log("error", error);
        toast.error("An error occurred while submitting your review.");
      },
      onSuccess: ({ data: reviewSubmitRating, status }) => {
        // console.log("reviewSubmitSuccess!!:", reviewSubmitRating);
      },
    });

  // Debounced API call
  const debouncedMutateReviewRating = React.useCallback(
    debounce((newRating) => {
      mutateReviewRating({
        qr_id: qrCodeObj?.id,
        rating: newRating.toString(),
      });
    }, 900),
    [mutateReviewRating, qrCodeObj?.id]
  );

  const handleRatingChange = (newRating) => {
    setRating(newRating);
    debouncedMutateReviewRating(newRating);
  };
  return (
    <form onSubmit={handleSubmit(onSubmit)} className="form-preview">
      {questions?.map((question, index) => (
        <div key={index} className="question-card">
          <p className="question-text">{question.text}</p>

          {/* Text Input */}
          {question?.type === "text" && (
            <Controller
              name={`question-${index}`}
              control={control}
              rules={{ required: "This field is required" }}
              render={({ field }) => (
                <div>
                  <input
                    {...field}
                    placeholder="Your answer here"
                    className="input-field"
                  />
                  {errors[`question-${index}`] && (
                    <p className="error-message">
                      {errors[`question-${index}`]?.message}
                    </p>
                  )}
                </div>
              )}
            />
          )}

          {/* Radio Input */}
          {question?.type === "radio" &&
            question?.options.map((option, optIndex) => (
              <label key={optIndex} className="radio-label">
                <Controller
                  name={`question-${index}`}
                  control={control}
                  rules={{ required: "Please select an option" }}
                  render={({ field }) => (
                    <div>
                      <input
                        {...field}
                        type="radio"
                        value={option}
                        className="radio-input"
                      />
                      {option}
                      {errors[`question-${index}`] && (
                        <p className="error-message">
                          {errors[`question-${index}`]?.message}
                        </p>
                      )}
                    </div>
                  )}
                />
              </label>
            ))}

          {/* Dropdown Input */}
          {question.type === "dropdown" && (
            <Controller
              name={`question-${index}`}
              control={control}
              rules={{ required: "Please select an option" }}
              render={({ field }) => (
                <div>
                  <select {...field} className="input-field">
                    <option value="" disabled>
                      Please Select Option
                    </option>
                    {question.options.map((option, optIndex) => (
                      <option key={optIndex} value={option}>
                        {option}
                      </option>
                    ))}
                  </select>
                  {errors[`question-${index}`] && (
                    <p className="error-message">
                      {errors[`question-${index}`]?.message}
                    </p>
                  )}
                </div>
              )}
            />
          )}

          {/* Checkbox Input */}
          {question.type === "checkbox" && (
            <Controller
              name={`question-${index}`}
              control={control}
              rules={{ required: "Please check this box" }}
              render={({ field }) => (
                <div>
                  <input
                    {...field}
                    type="checkbox"
                    className="checkbox-input"
                  />
                  {errors[`question-${index}`] && (
                    <p className="error-message">
                      {errors[`question-${index}`]?.message}
                    </p>
                  )}
                </div>
              )}
            />
          )}

          {/* Number Input */}
          {question.type === "number" && (
            <Controller
              name={`question-${index}`}
              control={control}
              rules={{
                required: "Please enter a number",
                min: { value: 1, message: "Number must be at least 1" },
                max: { value: 100, message: "Number must be less than 100" },
              }}
              render={({ field }) => (
                <div>
                  <input
                    {...field}
                    type="number"
                    placeholder="Number"
                    className="input-field"
                  />
                  {errors[`question-${index}`] && (
                    <p className="error-message">
                      {errors[`question-${index}`]?.message}
                    </p>
                  )}
                </div>
              )}
            />
          )}

          {/* Email Input */}
          {question.type === "email" && (
            <Controller
              name={`question-${index}`}
              control={control}
              rules={{
                required: "Email is required",
                pattern: {
                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                  message: "Invalid email address",
                },
              }} // Validation for email input
              render={({ field }) => (
                <div>
                  <input
                    {...field}
                    type="email"
                    placeholder="Email"
                    className="input-field"
                  />
                  {errors[`question-${index}`] && (
                    <p className="error-message">
                      {errors[`question-${index}`]?.message}
                    </p>
                  )}
                </div>
              )}
            />
          )}

          {/* Telephone Input */}
          {question.type === "tel" && (
            <Controller
              name={`question-${index}`}
              control={control}
              rules={{
                required: "Phone number is required",
                pattern: {
                  value: /^[0-9]{10}$/,
                  message: "Invalid phone number (10 digits required)",
                },
              }} // Validation for tel input
              render={({ field }) => (
                <div>
                  <input
                    {...field}
                    type="tel"
                    placeholder="Telephone"
                    className="input-field"
                  />
                  {errors[`question-${index}`] && (
                    <p className="error-message">
                      {errors[`question-${index}`]?.message}
                    </p>
                  )}
                </div>
              )}
            />
          )}

          {/* Password Input */}
          {question.type === "password" && (
            <Controller
              name={`question-${index}`}
              control={control}
              rules={{
                required: "Password is required",
                minLength: {
                  value: 6,
                  message: "Password must be at least 6 characters",
                },
              }} // Validation for password input
              render={({ field }) => (
                <div>
                  <input
                    {...field}
                    type="password"
                    placeholder="Password"
                    className="input-field"
                  />
                  {errors[`question-${index}`] && (
                    <p className="error-message">
                      {errors[`question-${index}`]?.message}
                    </p>
                  )}
                </div>
              )}
            />
          )}

          {/* Date Input */}
          {question.type === "date" && (
            <Controller
              name={`question-${index}`}
              control={control}
              rules={{ required: "Date is required" }}
              render={({ field }) => (
                <div>
                  <input {...field} type="date" className="input-field" />
                  {errors[`question-${index}`] && (
                    <p className="error-message">
                      {errors[`question-${index}`]?.message}
                    </p>
                  )}
                </div>
              )}
            />
          )}

          {/* Range Input */}
          {question.type === "range" && (
            <Controller
              name={`question-${index}`}
              control={control}
              rules={{ required: "Range value is required" }}
              render={({ field }) => (
                <div>
                  <input {...field} type="range" className="input-field" />
                  {errors[`question-${index}`] && (
                    <p className="error-message">
                      {errors[`question-${index}`]?.message}
                    </p>
                  )}
                </div>
              )}
            />
          )}

          {/* File Input */}
          {question.type === "file" && (
            <Controller
              name={`question-${index}`}
              control={control}
              rules={{ required: "Please upload a file" }}
              render={({ field }) => (
                <div>
                  <input {...field} type="file" className="input-field" />
                  {errors[`question-${index}`] && (
                    <p className="error-message">
                      {errors[`question-${index}`]?.message}
                    </p>
                  )}
                </div>
              )}
            />
          )}
        </div>
      ))}

      {qrCodeObj?.is_rating === "true" && (
        <div
          style={{
            margin: "16px 0px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <p style={{ fontWeight: "bold", marginBottom: "8px" }}>
            Rate Your Overall Experience
          </p>
          <Stack spacing={1}>
            <Rating
              name="size-medium"
              value={rating}
              precision={0.5}
              onChange={(event, newValue) => handleRatingChange(newValue)}
              disabled={isLoadingRating}
            />
          </Stack>
        </div>
      )}

      {questions.length > 0 && (
        <button type="submit" className="submit-btn" disabled={isLoading}>
          {isLoading ? "Submitting..." : "Submit"}
        </button>
      )}
    </form>
  );
};

export const QRPreviewElabelsWine = ({
  localQrData,
  className,
  showReview,
}) => {
  // console.log("winelocalQrData", localQrData);
  const { translatedData } = useSelector((state) => state?.language);
  const titleColor = localQrData?.title_color;
  const textColor = localQrData?.text_color;
  console.log("ncnnc", localQrData);
  return (
    <>
      <div
        className={`beer-container layout-content showBrowser ${className}`}
        style={{
          left: "4px",
          overflowX: "hidden",
          backgroundColor: localQrData?.color?.background,
        }}
      >
        {localQrData?.wine_image && (
          <div className="wine-header">
            <DynamicImage
              data={localQrData}
              imageKey="wine_image"
              altText="Wine Image"
              className="wine-image"
              style={{
                width: "100%",
                height: "200px",
                objectFit: "contain",
                borderRadius: "12px 12px 12px 12px",
              }}
            />
          </div>
        )}

        <div className="beer-content">
          {localQrData?.product_name && (
            <h2 className="beer-product-name">
              <FaWineGlassAlt className="icon-wine" />
              <span style={{ color: textColor }}>
                {" "}
                {/* {localQrData.product_name || "Wine Name"}{" "} */}
                {getTranslatedField(
                  translatedData,
                  localQrData,
                  "product_name"
                )}
              </span>
            </h2>
          )}
          {localQrData.sku_elables && (
            <p className="beer-sku" style={{ color: titleColor }}>
              <FaInfoCircle className="icon-info" />
              {getTranslatedField(translatedData, localQrData, "sku") ||
                "SKU"}:{" "}
              <span style={{ color: textColor }}>
                {localQrData.sku_elables}
              </span>
            </p>
          )}
          {localQrData?.alcohol_type && (
            <p>
              <strong  style={{ color: titleColor }}>
                {" "}
                {getTranslatedField(
                  translatedData,
                  localQrData,
                  "alcoholType"
                ) || "Alcohol Type"}
                :
              </strong>{" "}
              <span style={{ color: textColor }}>
                {" "}
                {/* {localQrData.alcohol_type || "N/A"}{" "} */}
                {getTranslatedField(
                  translatedData,
                  localQrData,
                  "alcohol_type"
                ) || "N/A"}
              </span>
            </p>
          )}
          {(localQrData?.select_type_wine || localQrData?.custom_type_wine) && (
            <p style={{ color: titleColor }}>
              <strong>
                {getTranslatedField(
                  translatedData,
                  localQrData,
                  "typeOfWine"
                ) || "Type of Wine"}
                :
              </strong>{" "}
              <span style={{ color: textColor }}>
                {localQrData?.select_type_wine === "other"
                  ? localQrData?.custom_type_wine || "N/A"
                  : localQrData?.select_type_wine
                      ?.replace(/_/g, " ")
                      ?.replace(/\b\w/g, (char) => char.toUpperCase()) ||
                    // localQrData?.custom_type_wine ||
                    // "N/A"
                    getTranslatedField(
                      translatedData,
                      localQrData,
                      "custom_type_wine"
                    ) ||
                    "N/A"}
              </span>
            </p>
          )}
          <div className="beer-details">
            {localQrData?.alcohol_percentage != 0 && (
              <p>
                <strong  style={{ color: titleColor }}>
                  {getTranslatedField(
                    translatedData,
                    localQrData,
                    "alcoholPercentage"
                  ) || "Alcohol Percentage"}
                  :
                </strong>{" "}
                <span style={{ color: textColor }}>
                  {" "}
                  {localQrData.alcohol_percentage || "0"}%{" "}
                </span>
              </p>
            )}

            {localQrData?.grape_variety && (
              <p style={{ color: titleColor }}>
                <strong>
                  {getTranslatedField(
                    translatedData,
                    localQrData,
                    "grapeVariety"
                  ) || "Grape Variety"}
                  :
                </strong>{" "}
                <span style={{ color: textColor }}>
                  {" "}
                  {/* {localQrData.grape_variety || "N/A"} */}
                  {getTranslatedField(
                    translatedData,
                    localQrData,
                    "grape_variety"
                  ) || "N/A"}
                </span>
              </p>
            )}

            {localQrData?.task_notes && (
              <p style={{ color: titleColor }}>
                <strong>
                  {getTranslatedField(
                    translatedData,
                    localQrData,
                    "tastingNote"
                  ) || "Tasting Notes"}
                  :
                </strong>{" "}
                <span style={{ color: textColor }}>
                  {" "}
                  {/* {localQrData.task_notes || "N/A"}{" "} */}
                  {getTranslatedField(
                    translatedData,
                    localQrData,
                    "task_notes"
                  ) || "N/A"}
                </span>
              </p>
            )}
            {localQrData?.year != 0 && (
              <p style={{ color: titleColor }}>
                <strong>
                  {getTranslatedField(translatedData, localQrData, "year") ||
                    "Year"}
                  :
                </strong>{" "}
                <span style={{ color: textColor }}>
                  {" "}
                  {localQrData.year || "N/A"}{" "}
                </span>
              </p>
            )}

            {localQrData?.drinking_temperature && (
              <p style={{ color: titleColor }}>
                <strong>
                  {getTranslatedField(
                    translatedData,
                    localQrData,
                    "drinkingTemperature"
                  ) || "Drinking Temperature"}
                  :
                </strong>{" "}
                <span style={{ color: textColor}}>
                  {/* {localQrData.drinking_temperature || "N/A"}{" "} */}
                  {getTranslatedField(
                    translatedData,
                    localQrData,
                    "drinking_temperature"
                  ) || "N/A"}
                </span>
              </p>
            )}

            {localQrData?.stored_temp_unopen && (
              <p style={{ color: titleColor }}>
                <strong>
                  {getTranslatedField(
                    translatedData,
                    localQrData,
                    "storeTempUnopen"
                  ) || "Stored Temp (Unopened)"}
                  :
                </strong>{" "}
                <span style={{ color: textColor }}>
                  {" "}
                  {/* {localQrData.stored_temp_unopen || "N/A"}{" "} */}
                  {getTranslatedField(
                    translatedData,
                    localQrData,
                    "stored_temp_unopen"
                  ) || "N/A"}
                </span>
              </p>
            )}

            {localQrData?.stored_temp_open && (
              <p style={{ color: titleColor }}>
                <strong>
                  {getTranslatedField(
                    translatedData,
                    localQrData,
                    "storeTempOpen"
                  ) || "Stored Temp (Opened)"}
                  :
                </strong>{" "}
                <span style={{ color: textColor }}>
                  {" "}
                  {/* {localQrData.stored_temp_open || "N/A"}{" "} */}
                  {getTranslatedField(
                    translatedData,
                    localQrData,
                    "stored_temp_open"
                  ) || "N/A"}
                </span>
              </p>
            )}

            {localQrData?.stored_days_open && (
              <p style={{ color: titleColor }}>
                <strong>
                  {getTranslatedField(
                    translatedData,
                    localQrData,
                    "dayStoreOpen"
                  ) || "Days Stored Open"}
                  :
                </strong>{" "}
                <span style={{ color: textColor }}>
                  {" "}
                  {localQrData.stored_days_open || "N/A"}{" "}
                </span>
              </p>
            )}
          </div>
          {localQrData?.description && (
            <p style={{ color: textColor ,fontSize:"13px",lineHeight:"15px"}}>
              {/* {localQrData.description || "N/A"} */}
              {getTranslatedField(translatedData, localQrData, "description") ||
                "N/A"}
            </p>
          )}
          {localQrData?.website && (
            <p className="beer-website" >
              <FaGlobe className="icon-globe" />
              <strong style={{ color: titleColor }}>
                {getTranslatedField(
                  translatedData,
                  localQrData,
                  "websiteElabels"
                ) || "Website"}
                :
              </strong>{" "}
              <a
                href={localQrData.website}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: textColor }}
              >
                {localQrData.website}
              </a>
            </p>
          )}
        </div>
        {localQrData.nutrition_image && (
          <footer className="beer-footer">
            <DynamicImage
              data={localQrData}
              imageKey="nutrition_image"
              altText="Nutrition Information"
              className="nutrition-image"
              style={{
                width: "100%",
                height: "120px",
                objectFit: "contain",
                borderRadius: "12px 12px 12px 12px",
              }}
            />
          </footer>
        )}

        {localQrData?.elables_social && (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              flexWrap: "wrap",
              gap: "12px",
              width: "100%",
              maxWidth: "700px",
              marginTop: "16px",
            }}
          >
            {Object.entries(localQrData?.elables_social).map(([key, url]) => {
              return (
                <a
                  key={key}
                  href={url}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    borderBottom: "1px solid #d9d9d9",
                    paddingBottom: "8px",
                    display: "flex",
                    textDecoration: "none",
                    alignItems: "center",
                    gap: "8px",
                    color: "#000",
                  }}
                >
                  {icons[key] || null}
                  <p
                    style={{
                      color: "#000",
                      fontWeight: "600",
                      margin: "0",
                      textTransform: "capitalize",
                    }}
                  >
                    {key}
                  </p>
                </a>
              );
            })}
          </div>
        )}
      </div>

      {/* Show Review Section */}
      {/* {showReview &&
        (localQrData?.questions.length > 0 ||
          localQrData?.is_rating === "true") && (
          <div className="review-container">
            <AccordianComponent title="📝 Share Your Feedback">
              <ReviewFormSubmit
                questions={localQrData?.questions}
                qrCodeObj={localQrData}
              />
            </AccordianComponent>
          </div>
        )} */}
    </>
  );
};

export const QRPreviewElabelsBeer = ({
  localQrData,
  className,
  showReview,
}) => {
  // console.log("localQrDatamm", localQrData?.alcohol_percentage !== 0);
  // console.log("localqrdata", localQrData);
  const { translatedData } = useSelector((state) => state?.language);
  const titleColor = localQrData?.title_color;
  return (
    <>
      <div
        className={`beer-container layout-content showBrowser ${className}`}
        style={{
          left: "4px",
          overflowX: "hidden",
          backgroundColor: localQrData?.color?.background,
        }}
      >
        <div className="beer-header">
          {localQrData?.beer_image && (
            <DynamicImage
              data={localQrData}
              imageKey="beer_image"
              altText="Beer Image"
              className="beer-image"
              style={{
                width: "100%",
                height: "200px",
                objectFit: "contain",
                borderRadius: "12px 12px 0 0",
              }}
            />
          )}
        </div>
        <div className="beer-content">
          {localQrData?.product_name && (
            <h2 className="beer-product-name">
              <FaBeer className="icon-beer" />
              <span style={{ color: localQrData?.text_color }}>
                {" "}
                {/* {localQrData.product_name}{" "} */}
                {getTranslatedField(
                  translatedData,
                  localQrData,
                  "product_name"
                )}
              </span>
            </h2>
          )}
          {localQrData?.sku_elables && (
            <p className="beer-sku" style={{ color: titleColor }}>
              <FaInfoCircle className="icon-info" />
              {getTranslatedField(translatedData, localQrData, "skuKey") ||
                "SKU"}
              :{" "}
              <span style={{ color: localQrData?.text_color }}>
                {/* {localQrData.sku} */}
                {getTranslatedField(translatedData, localQrData, "sku_elables")}
              </span>
            </p>
          )}
          {localQrData?.description && (
            <p
              className="beer-description"
              style={{ color: localQrData?.text_color,fontSize:"13px",lineHeight:"15px" }}
            >
              {/* {localQrData.description} */}
              {getTranslatedField(
                translatedData,
                localQrData,
                "description"
              )}{" "}
            </p>
          )}
          <div className="beer-details">
            {localQrData?.alcohol_percentage != 0 && (
              <p style={{ color: titleColor }}>
                <strong>
                  {" "}
                  {getTranslatedField(
                    translatedData,
                    localQrData,
                    "alcoholPercentage"
                  ) || "Alocohol Percentage"}
                  :{" "}
                </strong>{" "}
                <span style={{ color: localQrData?.text_color }}>
                  {" "}
                  {localQrData.alcohol_percentage}%{" "}
                </span>
              </p>
            )}

            {localQrData?.ipa && (
              <p>
                <strong style={{ color: titleColor }}>
                  {" "}
                  {getTranslatedField(translatedData, localQrData, "ipaKey") ||
                    "IPA"}
                  :
                </strong>{" "}
                <span style={{ color: localQrData?.text_color }}>
                  {" "}
                  {/* {localQrData.ipa}{" "} */}
                  {getTranslatedField(translatedData, localQrData, "ipa")}
                </span>
              </p>
            )}
            {localQrData?.brewed && (
              <p>
                <strong style={{ color: titleColor }}>
                  {" "}
                  {getTranslatedField(
                    translatedData,
                    localQrData,
                    "brewedAt"
                  ) || "Brewed At"}
                  :
                </strong>{" "}
                <span style={{ color: localQrData?.text_color }}>
                  {" "}
                  {/* {localQrData.brewed}{" "} */}
                  {getTranslatedField(translatedData, localQrData, "brewed")}
                </span>
              </p>
            )}
          </div>
          {localQrData?.website && (
            <p className="beer-website">
              <FaGlobe className="icon-globe" />
              <strong style={{ color: titleColor }}>
                {" "}
                {getTranslatedField(
                  translatedData,
                  localQrData,
                  "websiteElabels"
                ) || "Website"}
                :
              </strong>{" "}
              <a
                href={localQrData.website}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: localQrData?.text_color }}
              >
                {localQrData.website}
              </a>
            </p>
          )}
        </div>
        {localQrData?.nutrition_image && (
          <footer className="beer-footer">
            <DynamicImage
              data={localQrData}
              imageKey="nutrition_image"
              altText="Nutrition Information"
              className="nutrition-image"
              style={{
                width: "100%",
                height: "120px",
                objectFit: "contain",
                borderRadius: "12px 12px 12px 12px",
              }}
            />
          </footer>
        )}

        {localQrData?.elables_social && (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              flexWrap: "wrap",
              gap: "12px",
              width: "100%",
              maxWidth: "700px",
              marginTop: "16px",
            }}
          >
            {Object.entries(localQrData?.elables_social).map(([key, url]) => {
              return (
                <a
                  key={key}
                  href={url}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    borderBottom: "1px solid #d9d9d9",
                    paddingBottom: "8px",
                    display: "flex",
                    textDecoration: "none",
                    alignItems: "center",
                    gap: "8px",
                    color: "#000",
                  }}
                >
                  {icons[key] || null}
                  <p
                    style={{
                      color: "#000",
                      fontWeight: "600",
                      margin: "0",
                      textTransform: "capitalize",
                    }}
                  >
                    {key}
                  </p>
                </a>
              );
            })}
          </div>
        )}
      </div>
      {/* {showReview &&
          (localQrData?.questions.length > 0 ||
            localQrData?.is_rating === "true") && (
            <div className="review-container">
              <AccordianComponent title="📝 Share Your Feedback">
                <ReviewFormSubmit
                  questions={localQrData?.questions}
                  qrCodeObj={localQrData}
                />
              </AccordianComponent>
            </div>
          )} */}
    </>
  );
};

export const QRPreviewElabelsCigar = ({
  localQrData,
  className,
  showReview,
}) => {
  const { translatedData } = useSelector((state) => state?.language);
  const titleColor = localQrData?.title_color;
  return (
    <>
      <div
        className={`beer-container layout-content showBrowser ${className}`}
        style={{
          left: "4px",
          overflowX: "hidden",
          backgroundColor: localQrData?.color?.background,
        }}
      >
        <div className="beer-header">
          {localQrData?.cigar_image && (
            <DynamicImage
              data={localQrData}
              imageKey="cigar_image"
              altText="Cigar Image"
              className="beer-image"
              style={{
                width: "100%",
                height: "200px",
                objectFit: "contain",
                borderRadius: "12px 12px 12px 12px",
              }}
            />
          )}
        </div>
        <div className="beer-content">
          {localQrData?.product_name && (
            <h2 className="beer-product-name">
              <PiCigaretteBold className="icon-beer" />
              <span style={{ color: localQrData?.text_color }}>
                {/* {localQrData.product_name}{" "} */}
                {getTranslatedField(
                  translatedData,
                  localQrData,
                  "product_name"
                )}
              </span>
            </h2>
          )}
          {localQrData?.sku_elables && (
            <p className="beer-sku" style={{ color: titleColor }}>
              <FaInfoCircle className="icon-info" />
              {getTranslatedField(translatedData, localQrData, "skuKey") ||
                "SKU"}
              :{" "}
              <span style={{ color: localQrData?.text_color }}>
                {localQrData.sku_elables}
              </span>
            </p>
          )}
          {localQrData?.description && (
            <p
              className="beer-description"
              style={{ color: localQrData?.text_color,fontSize:"13px",lineHeight:"15px" }}
            >
              {" "}
              {/* {localQrData.description} */}
              {getTranslatedField(translatedData, localQrData, "description")}
            </p>
          )}
          <div className="beer-details">
            {localQrData?.where_it_is_made && (
              <p>
                <strong style={{ color: titleColor }}>
                  {" "}
                  {getTranslatedField(
                    translatedData,
                    localQrData,
                    "whereItMade"
                  ) || "Where It's Made "}
                  :
                </strong>{" "}
                <span style={{ color: localQrData?.text_color }}>
                  {" "}
                  {/* {localQrData.where_it_is_made}{" "} */}
                  {getTranslatedField(
                    translatedData,
                    localQrData,
                    "where_it_is_made"
                  )}
                </span>
              </p>
            )}
            {localQrData?.size && (
              <p>
                <strong style={{ color: titleColor }}>
                  {" "}
                  {getTranslatedField(translatedData, localQrData, "sizeKey") ||
                    "Size"}
                  :
                </strong>{" "}
                <span style={{ color: localQrData?.text_color }}>
                  {" "}
                  {/* {localQrData.size}{" "} */}
                  {getTranslatedField(translatedData, localQrData, "size")}
                </span>
              </p>
            )}
            {localQrData?.wrapper && (
              <p>
                <strong style={{ color: titleColor }}>
                  {" "}
                  {getTranslatedField(
                    translatedData,
                    localQrData,
                    "wrapperKey"
                  ) || "Wrapper"}
                  :
                </strong>{" "}
                <span style={{ color: localQrData?.text_color }}>
                  {" "}
                  {/* {localQrData.wrapper}{" "} */}
                  {getTranslatedField(translatedData, localQrData, "wrapper")}
                </span>
              </p>
            )}
            {localQrData?.binder && (
              <p>
                <strong style={{ color: titleColor }}>
                  {" "}
                  {getTranslatedField(
                    translatedData,
                    localQrData,
                    "binderKey"
                  ) || "Binder"}
                  :
                </strong>{" "}
                <span style={{ color: localQrData?.text_color }}>
                  {/* {localQrData.binder}{" "} */}
                  {getTranslatedField(translatedData, localQrData, "binder")}
                </span>
              </p>
            )}
            {localQrData?.filler && (
              <p>
                <strong style={{ color: titleColor }}>
                  {" "}
                  {getTranslatedField(
                    translatedData,
                    localQrData,
                    "fillerKey"
                  ) || "Filler"}
                  :
                </strong>{" "}
                <span style={{ color: localQrData?.text_color }}>
                  {/* {localQrData.filler}{" "} */}
                  {getTranslatedField(translatedData, localQrData, "filler")}
                </span>
              </p>
            )}
            {localQrData?.strength && (
              <p>
                <strong style={{ color: titleColor }}>
                  {" "}
                  {getTranslatedField(
                    translatedData,
                    localQrData,
                    "strengthKey"
                  ) || "Strength"}
                  :
                </strong>
                {/* {localQrData.strength} */}
                {getTranslatedField(translatedData, localQrData, "strength")}
              </p>
            )}
            {localQrData?.body && (
              <p>
                <strong style={{ color: titleColor }}>
                  {" "}
                  {getTranslatedField(translatedData, localQrData, "bodyKey") ||
                    "Body"}
                  :
                </strong>{" "}
                <span style={{ color: localQrData?.text_color }}>
                  {/* {localQrData.body}{" "} */}
                  {getTranslatedField(translatedData, localQrData, "body")}
                </span>
              </p>
            )}
            {localQrData?.flavour_profile && (
              <p>
                <strong style={{ color: titleColor }}>
                  {" "}
                  {getTranslatedField(
                    translatedData,
                    localQrData,
                    "flavourProfileKey"
                  ) || "Flavour Profile"}
                  :
                </strong>{" "}
                <span style={{ color: localQrData?.text_color }}>
                  {" "}
                  {/* {localQrData.flavour_profile}{" "} */}
                  {getTranslatedField(
                    translatedData,
                    localQrData,
                    "flavour_profile"
                  )}
                </span>
              </p>
            )}
            {localQrData?.best_paired_with && (
              <p>
                <strong style={{ color: titleColor }}>
                  {" "}
                  {getTranslatedField(
                    translatedData,
                    localQrData,
                    "bestPairedKey"
                  ) || "Best Paired With"}
                  :
                </strong>{" "}
                <span style={{ color: localQrData?.text_color }}>
                  {" "}
                  {/* {localQrData.best_paired_with}{" "} */}
                  {getTranslatedField(
                    translatedData,
                    localQrData,
                    "best_paired_with"
                  )}
                </span>
              </p>
            )}
          </div>
          {localQrData?.website && (
            <p className="beer-website">
              <FaGlobe className="icon-globe" />
              <strong style={{ color: titleColor }}>
                {" "}
                {getTranslatedField(
                  translatedData,
                  localQrData,
                  "websiteElabels"
                ) || "Website"}
                :
              </strong>{" "}
              <a
                href={localQrData.website}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: localQrData?.text_color }}
              >
                {localQrData.website}
              </a>
            </p>
          )}
        </div>

        {localQrData?.elables_social && (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              flexWrap: "wrap",
              gap: "12px",
              width: "100%",
              maxWidth: "700px",
              marginTop: "16px",
            }}
          >
            {Object.entries(localQrData?.elables_social).map(([key, url]) => {
              return (
                <a
                  key={key}
                  href={url}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    borderBottom: "1px solid #d9d9d9",
                    paddingBottom: "8px",
                    display: "flex",
                    textDecoration: "none",
                    alignItems: "center",
                    gap: "8px",
                    color: "#000",
                  }}
                >
                  {icons[key] || null}
                  <p
                    style={{
                      color: "#000",
                      fontWeight: "600",
                      margin: "0",
                      textTransform: "capitalize",
                    }}
                  >
                    {key}
                  </p>
                </a>
              );
            })}
          </div>
        )}
      </div>
      {/* {showReview &&
        (localQrData?.questions.length > 0 ||
          localQrData?.is_rating === "true") && (
          <div className="review-container">
            <AccordianComponent title="📝 Share Your Feedback">
              <ReviewFormSubmit
                questions={localQrData?.questions}
                qrCodeObj={localQrData}
              />
            </AccordianComponent>
          </div>
        )} */}
    </>
  );
};

export const QRPreviewElabelsCoffee = ({
  localQrData,
  className,
  showReview,
}) => {
  const { translatedData } = useSelector((state) => state?.language);
  const titleColor = localQrData?.title_color;
  return (
    <>
      <div
        className={`beer-container layout-content showBrowser ${className}`}
        style={{
          left: "4px",
          overflowX: "hidden",
          backgroundColor: localQrData?.color?.background,
        }}
      >
        <div className="beer-header">
          {localQrData.coffee_image && (
            <DynamicImage
              data={localQrData}
              imageKey="coffee_image"
              altText="Coffee Image"
              className="beer-image"
              style={{
                width: "100%",
                height: "200px",
                objectFit: "contain",
                borderRadius: "12px 12px 12px 12px",
              }}
            />
          )}
        </div>
        <div className="beer-content">
          {localQrData.product_name && (
            <h2 className="beer-product-name">
              <FaCoffee className="icon-coffee" />
              <span style={{ color: localQrData?.text_color }}>
                {" "}
                {/* {localQrData.product_name}{" "} */}
                {getTranslatedField(
                  translatedData,
                  localQrData,
                  "product_name"
                )}
              </span>
            </h2>
          )}

          {localQrData.sku_elables && (
            <p className="beer-sku" style={{ color: titleColor }}>
              <FaInfoCircle className="icon-info" />
              {getTranslatedField(translatedData, localQrData, "skuKey") ||
                "SKU"}
              :{" "}
              <span style={{ color: localQrData?.text_color }}>
                {getTranslatedField(translatedData, localQrData, "sku_elables")}
              </span>
            </p>
          )}

          {localQrData.description && (
            <p
              className="beer-description"
              style={{ color: localQrData?.text_color,fontSize:"13px",lineHeight:"15px" }}
            >
              {/* {localQrData.description} */}
              {getTranslatedField(translatedData, localQrData, "description")}
            </p>
          )}

          <div className="beer-details">
            {localQrData.origin && (
              <p>
                <strong style={{ color: titleColor }}>
                  {" "}
                  {getTranslatedField(
                    translatedData,
                    localQrData,
                    "originKey"
                  ) || "Origin"}
                  :
                </strong>{" "}
                <span style={{ color: localQrData?.text_color }}>
                  {/* {localQrData.origin} */}
                  {getTranslatedField(translatedData, localQrData, "origin")}
                </span>
              </p>
            )}
            {localQrData.farm && (
              <p>
                <strong style={{ color: titleColor }}>
                  {" "}
                  {getTranslatedField(translatedData, localQrData, "farmKey") ||
                    "Farm"}
                  :
                </strong>{" "}
                <span style={{ color: localQrData?.text_color }}>
                  {/* {localQrData.farm} */}
                  {getTranslatedField(translatedData, localQrData, "farm")}
                </span>
              </p>
            )}
            {localQrData.altitude != 0 && (
              <p>
                <strong style={{ color: titleColor }}>
                  {" "}
                  {getTranslatedField(
                    translatedData,
                    localQrData,
                    "altitudeKey"
                  ) || "Altitude"}
                  :
                </strong>{" "}
                <span style={{ color: localQrData?.text_color }}>
                  {localQrData.altitude}m{" "}
                  {/* {getTranslatedField(translatedData, localQrData, "altitude")} */}
                </span>
              </p>
            )}
            {localQrData.roast && (
              <p>
                <strong style={{ color: titleColor }}>
                  {" "}
                  {getTranslatedField(
                    translatedData,
                    localQrData,
                    "roastKey"
                  ) || "Roast"}
                  :
                </strong>{" "}
                <span style={{ color: localQrData?.text_color }}>
                  {/* {localQrData.roast} */}
                  {getTranslatedField(translatedData, localQrData, "roast")}
                </span>
              </p>
            )}
            {localQrData.flavour && (
              <p>
                <strong style={{ color: titleColor }}>
                  {" "}
                  {getTranslatedField(
                    translatedData,
                    localQrData,
                    "flavourKey"
                  ) || "Flavour"}
                  :
                </strong>{" "}
                <span style={{ color: localQrData?.text_color }}>
                  {/* {localQrData.flavour} */}
                  {getTranslatedField(translatedData, localQrData, "flavour")}
                </span>
              </p>
            )}
          </div>

          {localQrData.task_notes && (
            <p className="beer-task-notes">
              <strong style={{ color: titleColor }}>
                {" "}
                {getTranslatedField(
                  translatedData,
                  localQrData,
                  "taskNoteKey"
                ) || "Task Notes"}
                :
              </strong>{" "}
              <span style={{ color: localQrData?.text_color }}>
                {/* {localQrData.task_notes} */}
                {getTranslatedField(translatedData, localQrData, "task_notes")}
              </span>
            </p>
          )}

          {localQrData.ingredients && (
            <p className="beer-ingredients">
              <strong style={{ color: titleColor }}>
                {" "}
                {getTranslatedField(
                  translatedData,
                  localQrData,
                  "ingredientsKey"
                ) || "Ingredients"}
                :
              </strong>{" "}
              <span style={{ color: localQrData?.text_color }}>
                {/* {localQrData.ingredients} */}
                {getTranslatedField(translatedData, localQrData, "ingredients")}
              </span>
            </p>
          )}

          {localQrData.website && (
            <p className="beer-website">
              <FaGlobe className="icon-globe" />
              <strong style={{ color: titleColor }}>
                {getTranslatedField(
                  translatedData,
                  localQrData,
                  "websiteElabels"
                ) || "Website"}
                :
              </strong>{" "}
              <a
                href={localQrData.website}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: localQrData?.text_color }}
              >
                {localQrData.website}
              </a>
            </p>
          )}

          {localQrData.storage && (
            <div className="beer-storage">
              <p>
                <strong style={{ color: titleColor }}>
                  {getTranslatedField(
                    translatedData,
                    localQrData,
                    "storageKey"
                  ) || "Storage"}
                  :
                </strong>{" "}
                <span style={{ color: localQrData?.text_color }}>
                  {/* {localQrData.storage} */}
                  {getTranslatedField(translatedData, localQrData, "storage")}
                </span>
              </p>
            </div>
          )}

          <div className="beer-certifications">
            {localQrData.organic !== false && (
              <p>
                <strong style={{ color: titleColor }}>
                  {" "}
                  {getTranslatedField(
                    translatedData,
                    localQrData,
                    "organicKey"
                  ) || "Organic"}
                  :
                </strong>{" "}
                {localQrData.organic ? (
                  <FaCheck style={{ color: "green" }} />
                ) : (
                  <FaTimes style={{ color: "red" }} />
                )}
              </p>
            )}
            {localQrData.free_trade !== false && (
              <p>
                <strong style={{ color: titleColor }}>
                  {" "}
                  {getTranslatedField(
                    translatedData,
                    localQrData,
                    "fareTradeKey"
                  ) || "Fare Trade"}
                  :
                </strong>{" "}
                {localQrData.free_trade ? (
                  <FaCheck style={{ color: "green" }} />
                ) : (
                  <FaTimes style={{ color: "red" }} />
                )}
              </p>
            )}
          </div>
        </div>

        {localQrData.nutrition_image && (
          <footer className="beer-footer">
            <DynamicImage
              data={localQrData}
              imageKey="nutrition_image"
              altText="Nutrition Information"
              className="nutrition-image"
              style={{
                width: "100%",
                height: "120px",
                objectFit: "contain",
                borderRadius: "12px 12px 12px 12px",
              }}
            />
          </footer>
        )}

        {localQrData?.elables_social && (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              flexWrap: "wrap",
              gap: "12px",
              width: "100%",
              maxWidth: "700px",
              marginTop: "16px",
            }}
          >
            {Object.entries(localQrData?.elables_social).map(([key, url]) => {
              return (
                <a
                  key={key}
                  href={url}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    borderBottom: "1px solid #d9d9d9",
                    paddingBottom: "8px",
                    display: "flex",
                    textDecoration: "none",
                    alignItems: "center",
                    gap: "8px",
                    color: "#000",
                  }}
                >
                  {icons[key] || null}
                  <p
                    style={{
                      color: "#000",
                      fontWeight: "600",
                      margin: "0",
                      textTransform: "capitalize",
                    }}
                  >
                    {key}
                  </p>
                </a>
              );
            })}
          </div>
        )}
      </div>

      {/* {showReview &&
        (localQrData?.questions.length > 0 ||
          localQrData?.is_rating === "true") && (
          <div className="review-container">
            <AccordianComponent title="📝 Share Your Feedback">
              <ReviewFormSubmit
                questions={localQrData?.questions}
                qrCodeObj={localQrData}
              />
            </AccordianComponent>
          </div>
        )} */}
    </>
  );
};

export const QRPreviewElabelsFood = ({
  localQrData,
  className,
  showReview,
}) => {
  const { translatedData } = useSelector((state) => state?.language);
  const titleColor = localQrData?.title_color;
  return (
    <>
      <div
        className={`beer-container layout-content showBrowser ${className}`}
        style={{
          left: "4px",
          overflowX: "hidden",
          backgroundColor: localQrData?.color?.background,
        }}
      >
        <div className="beer-header">
          {localQrData.food_image && (
            <DynamicImage
              data={localQrData}
              imageKey="food_image"
              altText="Food Image"
              className="beer-image"
              style={{
                width: "100%",
                height: "200px",
                objectFit: "contain",
                borderRadius: "12px 12px 12px 12px",
              }}
            />
          )}
        </div>
        <div className="beer-content">
          {localQrData.product_name && (
            <h2 className="beer-product-name">
              <FaUtensils className="icon-utensils" />
              <span style={{ color: localQrData?.text_color }}>
                {" "}
                {/* {localQrData.product_name}{" "} */}
                {getTranslatedField(
                  translatedData,
                  localQrData,
                  "product_name"
                )}
              </span>
            </h2>
          )}

          {localQrData.sku_elables && (
            <p className="beer-sku" style={{ color: titleColor }}>
              <FaInfoCircle className="icon-info" />
              {getTranslatedField(translatedData, localQrData, "skuKey") ||
                "SKU"}
              :{" "}
              <span style={{ color: localQrData?.text_color }}>
                {getTranslatedField(translatedData, localQrData, "sku_elables")}
              </span>
            </p>
          )}

          {localQrData.cuisine && (
            <p className="beer-sku" style={{ color: titleColor }}>
              <FaInfoCircle className="icon-info" />
              {getTranslatedField(translatedData, localQrData, "cuisineKey") ||
                "Cuisine"}
              :{" "}
              <span style={{ color: localQrData?.text_color }}>
                {/* {localQrData.cuisine} */}
                {getTranslatedField(translatedData, localQrData, "cuisine")}
              </span>
            </p>
          )}

          {localQrData.ingredients && (
            <p className="beer-description">
              <strong style={{ color: titleColor }}>
                {" "}
                {getTranslatedField(
                  translatedData,
                  localQrData,
                  "ingredientsKey"
                ) || "Ingredients"}
                :
              </strong>{" "}
              <span style={{ color: localQrData?.text_color }}>
                {/* {localQrData.ingredients}{" "} */}
                {getTranslatedField(translatedData, localQrData, "ingredients")}
              </span>
            </p>
          )}

          {localQrData.size && (
            <p className="beer-description">
              <strong style={{ color: titleColor }}>
                {getTranslatedField(
                  translatedData,
                  localQrData,
                  "servingSizeKey"
                ) || "Serving Size"}
                :
              </strong>{" "}
              <span style={{ color: localQrData?.text_color }}>
                {/* {localQrData.size} */}
                {getTranslatedField(translatedData, localQrData, "size")}
              </span>
            </p>
          )}

          {localQrData.clories && (
            <p className="beer-description">
              <strong style={{ color: titleColor }}>
                {" "}
                {getTranslatedField(
                  translatedData,
                  localQrData,
                  "caloriesKey"
                ) || "Calories"}
                :
              </strong>{" "}
              <span style={{ color: localQrData?.text_color }}>
                {localQrData.clories}
              </span>
            </p>
          )}

          {localQrData.website && (
            <p className="beer-website">
              <FaGlobe className="icon-globe" />
              <strong style={{ color: titleColor }}>
                {" "}
                {getTranslatedField(
                  translatedData,
                  localQrData,
                  "websiteElabels"
                ) || "Website"}
                :
              </strong>{" "}
              <a
                href={localQrData.website}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: localQrData?.text_color }}
              >
                {localQrData.website}
              </a>
            </p>
          )}
        </div>
        {localQrData?.elables_social && (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              flexWrap: "wrap",
              gap: "12px",
              width: "100%",
              maxWidth: "700px",
              marginTop: "16px",
            }}
          >
            {Object.entries(localQrData?.elables_social).map(([key, url]) => {
              return (
                <a
                  key={key}
                  href={url}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    borderBottom: "1px solid #d9d9d9",
                    paddingBottom: "8px",
                    display: "flex",
                    textDecoration: "none",
                    alignItems: "center",
                    gap: "8px",
                    color: "#000",
                  }}
                >
                  {icons[key] || null}
                  <p
                    style={{
                      color: "#000",
                      fontWeight: "600",
                      margin: "0",
                      textTransform: "capitalize",
                    }}
                  >
                    {key}
                  </p>
                </a>
              );
            })}
          </div>
        )}
      </div>
      {/* 
      {showReview &&
        (localQrData?.questions.length > 0 ||
          localQrData?.is_rating === "true") && (
          <div className="review-container">
            <AccordianComponent title="📝 Share Your Feedback">
              <ReviewFormSubmit
                questions={localQrData?.questions}
                qrCodeObj={localQrData}
              />
            </AccordianComponent>
          </div>
        )} */}
    </>
  );
};

export const QRPreviewElabelsProduct = ({
  localQrData,
  className,
  showReview,
}) => {
  const { translatedData } = useSelector((state) => state?.language);
  const titleColor = localQrData?.title_color;
  return (
    <>
      <div
        className={`beer-container layout-content showBrowser ${className}`}
        style={{
          left: "4px",
          overflowX: "hidden",
          backgroundColor: localQrData?.color?.background,
        }}
      >
        <div className="beer-header">
          {localQrData.product_image && (
            <DynamicImage
              data={localQrData}
              imageKey="product_image"
              altText="Product Image"
              className="beer-image"
              style={{
                width: "100%",
                height: "200px",
                objectFit: "contain",
                borderRadius: "12px 12px 12px 12px",
              }}
            />
          )}
        </div>
        <div className="beer-content">
          {localQrData.product_name && (
            <h2 className="beer-product-name">
              <FaTag className="icon-tag" />
              <span style={{ color: localQrData?.text_color }}>
                {/* {localQrData.product_name}{" "} */}
                {getTranslatedField(
                  translatedData,
                  localQrData,
                  "product_name"
                )}
              </span>
            </h2>
          )}

          {localQrData.sku_elables && (
            <p className="beer-sku" style={{ color: titleColor }}>
              <FaInfoCircle className="icon-info" />
              {getTranslatedField(translatedData, localQrData, "skuKey") ||
                "SKU"}
              :{" "}
              <span style={{ color: localQrData?.text_color }}>
                {getTranslatedField(translatedData, localQrData, "sku_elables")}
              </span>
            </p>
          )}

          {localQrData.description && (
            <p
              className="beer-description"
              style={{ color: localQrData?.text_color,fontSize:"13px",lineHeight:"15px" }}
            >
              {/* {localQrData.description} */}
              {getTranslatedField(translatedData, localQrData, "description")}
            </p>
          )}

          {localQrData.directions && (
            <p className="beer-description">
              <strong style={{ color: titleColor }}>
                {" "}
                {getTranslatedField(
                  translatedData,
                  localQrData,
                  "directionKey"
                ) || "Directions"}
                :
              </strong>{" "}
              <span style={{ color: localQrData?.text_color }}>
                {/* {localQrData.directions} */}
                {getTranslatedField(translatedData, localQrData, "directions")}
              </span>
            </p>
          )}

          {localQrData.brand && (
            <p className="beer-description">
              <strong style={{ color: titleColor }}>
                {" "}
                {getTranslatedField(translatedData, localQrData, "brandKey") ||
                  "Brand"}
                :
              </strong>{" "}
              <span style={{ color: localQrData?.text_color }}>
                {/* {localQrData.brand} */}
                {getTranslatedField(translatedData, localQrData, "brand")}
              </span>
            </p>
          )}

          {localQrData.category && (
            <p className="beer-description">
              <strong style={{ color: titleColor }}>
                {" "}
                {getTranslatedField(
                  translatedData,
                  localQrData,
                  "categoryKey"
                ) || "Category"}
                :
              </strong>{" "}
              <span style={{ color: localQrData?.text_color }}>
                {/* {localQrData.category} */}
                {getTranslatedField(translatedData, localQrData, "category")}
              </span>
            </p>
          )}

          {localQrData.price != 0 && (
            <p className="beer-description">
              <strong style={{ color: titleColor }}>
                {getTranslatedField(translatedData, localQrData, "priceKey") ||
                  "Price"}
                :
              </strong>{" "}
              <span style={{ color: localQrData?.text_color }}>
                {/* ${localQrData.price} */}
                {getTranslatedField(translatedData, localQrData, "price")}
              </span>
            </p>
          )}

          {localQrData.warning && (
            <p className="beer-warning">
              <FaExclamationCircle className="icon-warning" />
              <strong style={{ color: titleColor }}>
                {getTranslatedField(
                  translatedData,
                  localQrData,
                  "warningKey"
                ) || "Warning"}
                :
              </strong>{" "}
              <span style={{ color: localQrData?.text_color }}>
                {/* {localQrData.warning} */}
                {getTranslatedField(translatedData, localQrData, "warning")}
              </span>
            </p>
          )}
        </div>
        {localQrData?.elables_social && (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              flexWrap: "wrap",
              gap: "12px",
              width: "100%",
              maxWidth: "700px",
              marginTop: "16px",
            }}
          >
            {Object.entries(localQrData?.elables_social).map(([key, url]) => {
              return (
                <a
                  key={key}
                  href={url}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    borderBottom: "1px solid #d9d9d9",
                    paddingBottom: "8px",
                    display: "flex",
                    textDecoration: "none",
                    alignItems: "center",
                    gap: "8px",
                    color: "#000",
                  }}
                >
                  {icons[key] || null}
                  <p
                    style={{
                      color: "#000",
                      fontWeight: "600",
                      margin: "0",
                      textTransform: "capitalize",
                    }}
                  >
                    {key}
                  </p>
                </a>
              );
            })}
          </div>
        )}
      </div>

      {/* {showReview &&
        (localQrData?.questions.length > 0 ||
          localQrData?.is_rating === "true") && (
          <div className="review-container">
            <AccordianComponent title="📝 Share Your Feedback">
              <ReviewFormSubmit
                questions={localQrData?.questions}
                qrCodeObj={localQrData}
              />
            </AccordianComponent>
          </div>
        )} */}
    </>
  );
};

// ELABELS AFTER SCAN SCREENS

export const QRPreviewElabelsWineScan = ({
  localQrData,
  className,
  showReview,
}) => {
  const { translatedData } = useSelector((state) => state?.language);

  const rowStyle = {
    display: "flex",
    justifyContent: "space-between",
    borderBottom: "1px solid #000",
    padding: "8px 0",
    flexWrap: "wrap",
  };

  const labelStyle = {
    fontWeight: "bold",
    flex: "1 1 40%",
    color: "#000",
  };

  const valueStyle = {
    flex: "1 1 60%",
    color: localQrData?.text_color || "#333",
  };

  const titleColor = localQrData?.title_color;
  return (
    <div
      className={`beer-container layout-content showBrowser ${className}`}
      style={{
        left: "4px",
        overflowX: "hidden",
        backgroundColor: localQrData?.color?.background,
        padding: "16px",
        borderRadius: "12px",
        maxWidth: "800px",
        margin: "0 auto",
        boxSizing: "border-box",
      }}
    >
      {localQrData?.wine_image && (
        <div style={{ marginBottom: "16px" }}>
          <DynamicImage
            data={localQrData}
            imageKey="wine_image"
            altText="Wine Image"
            className="wine-image"
            style={{
              width: "100%",
              height: "200px",
              objectFit: "contain",
              borderRadius: "12px",
            }}
          />
        </div>
      )}

      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          marginBottom: "16px",
          flexWrap: "wrap",
          justifyContent: "center",
        }}
      >
        <FaWineGlassAlt size={25} />
        <h2
          style={{
            display: "inline-block",
            backgroundColor: "#f9f9f9",
            color: "#333",
            padding: "6px 14px",
            borderRadius: "999px",
            fontSize: "30px",
            fontWeight: "600",
            textTransform: "capitalize",
            letterSpacing: "0.5px",
            boxShadow: "0 2px 6px rgba(0, 0, 0, 0.05)",
            border: "1px solid #ddd",
          }}
        >
          {getTranslatedField(translatedData, localQrData, "product_name")}
        </h2>
      </div>

      {/* Data Table */}
      <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
        {localQrData?.sku_elables && (
          <div style={rowStyle}>
            <div style={{ ...labelStyle, color: titleColor }}>
              <FaInfoCircle style={{ marginRight: "4px" }} />
              {getTranslatedField(translatedData, localQrData, "sku") || "SKU"}
            </div>
            <div style={valueStyle}>{localQrData.sku_elables}</div>
          </div>
        )}

        {localQrData?.alcohol_type && (
          <div style={rowStyle}>
            <div style={{ ...labelStyle, color: titleColor }}>
              {getTranslatedField(translatedData, localQrData, "alcoholType") ||
                "Alcohol Type"}
            </div>
            <div style={valueStyle}>
              {getTranslatedField(
                translatedData,
                localQrData,
                "alcohol_type"
              ) || "N/A"}
            </div>
          </div>
        )}

        {(localQrData?.select_type_wine || localQrData?.custom_type_wine) && (
          <div style={rowStyle}>
            <div style={{ ...labelStyle, color: titleColor }}>
              {getTranslatedField(translatedData, localQrData, "typeOfWine") ||
                "Type of Wine"}
            </div>
            <div style={valueStyle}>
              {localQrData?.select_type_wine === "other"
                ? localQrData?.custom_type_wine || "N/A"
                : localQrData?.select_type_wine
                    ?.replace(/_/g, " ")
                    ?.replace(/\b\w/g, (char) => char.toUpperCase()) ||
                  getTranslatedField(
                    translatedData,
                    localQrData,
                    "custom_type_wine"
                  ) ||
                  "N/A"}
            </div>
          </div>
        )}

        {localQrData?.alcohol_percentage != 0 && (
          <div style={rowStyle}>
            <div style={{ ...labelStyle, color: titleColor }}>
              {getTranslatedField(
                translatedData,
                localQrData,
                "alcoholPercentage"
              ) || "Alcohol Percentage"}
            </div>
            <div style={valueStyle}>{localQrData.alcohol_percentage}%</div>
          </div>
        )}

        {localQrData?.grape_variety && (
          <div style={rowStyle}>
            <div style={{ ...labelStyle, color: titleColor }}>
              {getTranslatedField(
                translatedData,
                localQrData,
                "grapeVariety"
              ) || "Grape Variety"}
            </div>
            <div style={valueStyle}>
              {getTranslatedField(
                translatedData,
                localQrData,
                "grape_variety"
              ) || "N/A"}
            </div>
          </div>
        )}

        {localQrData?.task_notes && (
          <div style={rowStyle}>
            <div style={{ ...labelStyle, color: titleColor }}>
              {getTranslatedField(translatedData, localQrData, "tastingNote") ||
                "Tasting Notes"}
            </div>
            <div style={valueStyle}>
              {getTranslatedField(translatedData, localQrData, "task_notes") ||
                "N/A"}
            </div>
          </div>
        )}

        {localQrData?.year != 0 && (
          <div style={rowStyle}>
            <div style={{ ...labelStyle, color: titleColor }}>
              {getTranslatedField(translatedData, localQrData, "yearTitle") ||
                "Year"}
            </div>
            <div style={valueStyle}>{localQrData.year || "N/A"}</div>
          </div>
        )}

        {localQrData?.drinking_temperature && (
          <div style={rowStyle}>
            <div style={{ ...labelStyle, color: titleColor }}>
              {getTranslatedField(
                translatedData,
                localQrData,
                "drinkingTemperature"
              ) || "Drinking Temp"}
            </div>
            <div style={valueStyle}>
              {getTranslatedField(
                translatedData,
                localQrData,
                "drinking_temperature"
              ) || "N/A"}
            </div>
          </div>
        )}

        {localQrData?.stored_temp_unopen && (
          <div style={rowStyle}>
            <div style={{ ...labelStyle, color: titleColor }}>
              {getTranslatedField(
                translatedData,
                localQrData,
                "storeTempUnopen"
              ) || "Stored Temp (Unopened)"}
            </div>
            <div style={valueStyle}>
              {getTranslatedField(
                translatedData,
                localQrData,
                "stored_temp_unopen"
              ) || "N/A"}
            </div>
          </div>
        )}

        {localQrData?.stored_temp_open && (
          <div style={rowStyle}>
            <div style={{ ...labelStyle, color: titleColor }}>
              {getTranslatedField(
                translatedData,
                localQrData,
                "storeTempOpen"
              ) || "Stored Temp (Opened)"}
            </div>
            <div style={valueStyle}>
              {getTranslatedField(
                translatedData,
                localQrData,
                "stored_temp_open"
              ) || "N/A"}
            </div>
          </div>
        )}

        {localQrData?.stored_days_open && (
          <div style={rowStyle}>
            <div style={{ ...labelStyle, color: titleColor }}>
              {getTranslatedField(
                translatedData,
                localQrData,
                "dayStoreOpen"
              ) || "Days Stored Open"}
            </div>
            <div style={valueStyle}>
              {localQrData.stored_days_open || "N/A"}
            </div>
          </div>
        )}

        {localQrData?.description && (
          <div style={rowStyle}>
            <div style={{ ...labelStyle, color: titleColor }}>
              {getTranslatedField(
                translatedData,
                localQrData,
                "descriptionKey"
              ) || "Description"}
            </div>
            <div style={valueStyle}>
              {getTranslatedField(translatedData, localQrData, "description") ||
                "N/A"}
            </div>
          </div>
        )}

        {localQrData?.website && (
          <div style={rowStyle}>
            <div style={{ ...labelStyle, color: titleColor }}>
              <FaGlobe style={{ marginRight: "4px" }} />
              {getTranslatedField(
                translatedData,
                localQrData,
                "websiteElabels"
              ) || "Website"}
            </div>
            <div style={valueStyle}>
              <a
                href={localQrData.website}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  color: localQrData?.text_color,
                  textDecoration: "underline",
                }}
              >
                {localQrData.website}
              </a>
            </div>
          </div>
        )}
      </div>

      {localQrData.nutrition_image && (
        <footer style={{ marginTop: "16px" }}>
          <DynamicImage
            data={localQrData}
            imageKey="nutrition_image"
            altText="Nutrition Information"
            className="nutrition-image"
            style={{
              width: "100%",
              height: "120px",
              objectFit: "contain",
              borderRadius: "12px",
            }}
          />
        </footer>
      )}

      {localQrData?.elables_social && (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "12px",
            marginTop: "16px",
            borderTop: "1px solid #ddd",
            paddingTop: "16px",
          }}
        >
          {Object.entries(localQrData.elables_social).map(([key, url]) => (
            <a
              key={key}
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: "flex",
                alignItems: "center",
                textDecoration: "none",
                color: "#000",
                gap: "8px",
                fontWeight: "500",
              }}
            >
              {icons[key] || null}
              <span style={{ textTransform: "capitalize" }}>{key}</span>
            </a>
          ))}
        </div>
      )}
    </div>
  );
};

export const QRPreviewElabelsBeerScan = ({
  localQrData,
  className,
  showReview,
}) => {
  const { translatedData } = useSelector((state) => state?.language);

  const rowStyle = {
    display: "flex",
    justifyContent: "space-between",
    borderBottom: "1px solid #000",
    padding: "8px 0",
    flexWrap: "wrap",
  };

  const labelStyle = {
    fontWeight: "bold",
    flex: "1 1 40%",
    color: "#000",
  };

  const valueStyle = {
    flex: "1 1 60%",
    color: localQrData?.text_color || "#333",
  };
  const titleColor = localQrData?.title_color;
  return (
    <div
      className={`beer-container layout-content showBrowser ${className}`}
      style={{
        left: "4px",
        overflowX: "hidden",
        backgroundColor: localQrData?.color?.background,
        padding: "16px",
        borderRadius: "12px",
        maxWidth: "800px",
        margin: "0 auto",
        boxSizing: "border-box",
      }}
    >
      {localQrData?.beer_image && (
        <div style={{ marginBottom: "16px" }}>
          <DynamicImage
            data={localQrData}
            imageKey="beer_image"
            altText="Beer Image"
            className="beer-image"
            style={{
              width: "100%",
              height: "200px",
              objectFit: "contain",
              borderRadius: "12px",
            }}
          />
        </div>
      )}

      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          marginBottom: "16px",
          flexWrap: "wrap",
          justifyContent: "center",
        }}
      >
        <FaWineGlassAlt size={25} />
        <h2
          style={{
            display: "inline-block",
            backgroundColor: "#f9f9f9",
            color: "#333",
            padding: "6px 14px",
            borderRadius: "999px",
            fontSize: "30px",
            fontWeight: "600",
            textTransform: "capitalize",
            letterSpacing: "0.5px",
            boxShadow: "0 2px 6px rgba(0, 0, 0, 0.05)",
            border: "1px solid #ddd",
          }}
        >
          {getTranslatedField(translatedData, localQrData, "product_name")}
        </h2>
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
        {localQrData?.sku_elables && (
          <div style={rowStyle}>
            <div style={{ ...labelStyle, color: titleColor }}>
              <FaInfoCircle style={{ marginRight: "4px" }} />
              {getTranslatedField(translatedData, localQrData, "skuKey") ||
                "SKU"}
            </div>
            <div style={valueStyle}>
              {getTranslatedField(translatedData, localQrData, "sku_elables")}
            </div>
          </div>
        )}

        {localQrData?.alcohol_percentage != 0 && (
          <div style={rowStyle}>
            <div style={{ ...labelStyle, color: titleColor }}>
              {getTranslatedField(
                translatedData,
                localQrData,
                "alcoholPercentage"
              ) || "Alcohol Percentage"}
            </div>
            <div style={valueStyle}>{localQrData.alcohol_percentage}%</div>
          </div>
        )}

        {localQrData?.ipa && (
          <div style={rowStyle}>
            <div style={{ ...labelStyle, color: titleColor }}>
              {getTranslatedField(translatedData, localQrData, "ipaKey") ||
                "IPA"}
            </div>
            <div style={valueStyle}>
              {getTranslatedField(translatedData, localQrData, "ipa")}
            </div>
          </div>
        )}

        {localQrData?.brewed && (
          <div style={rowStyle}>
            <div style={{ ...labelStyle, color: titleColor }}>
              {getTranslatedField(translatedData, localQrData, "brewedAt") ||
                "Brewed At"}
            </div>
            <div style={valueStyle}>
              {getTranslatedField(translatedData, localQrData, "brewed")}
            </div>
          </div>
        )}

        {localQrData?.description && (
          <div style={rowStyle}>
            <div style={{ ...labelStyle, color: titleColor }}>
              {getTranslatedField(
                translatedData,
                localQrData,
                "descriptionKey"
              ) || "Description"}
            </div>
            <div style={valueStyle}>
              {getTranslatedField(translatedData, localQrData, "description")}
            </div>
          </div>
        )}

        {localQrData?.website && (
          <div style={rowStyle}>
            <div style={{ ...labelStyle, color: titleColor }}>
              <FaGlobe style={{ marginRight: "4px" }} />
              {getTranslatedField(
                translatedData,
                localQrData,
                "websiteElabels"
              ) || "Website"}
            </div>
            <div style={valueStyle}>
              <a
                href={localQrData.website}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  color: localQrData?.text_color,
                  textDecoration: "underline",
                }}
              >
                {localQrData.website}
              </a>
            </div>
          </div>
        )}
      </div>

      {localQrData?.nutrition_image && (
        <footer style={{ marginTop: "16px" }}>
          <DynamicImage
            data={localQrData}
            imageKey="nutrition_image"
            altText="Nutrition Information"
            className="nutrition-image"
            style={{
              width: "100%",
              height: "120px",
              objectFit: "contain",
              borderRadius: "12px",
            }}
          />
        </footer>
      )}

      {localQrData?.elables_social && (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "12px",
            marginTop: "16px",
            borderTop: "1px solid #ddd",
            paddingTop: "16px",
          }}
        >
          {Object.entries(localQrData.elables_social).map(([key, url]) => (
            <a
              key={key}
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: "flex",
                alignItems: "center",
                textDecoration: "none",
                color: "#000",
                gap: "8px",
                fontWeight: "500",
              }}
            >
              {icons[key] || null}
              <span style={{ textTransform: "capitalize" }}>{key}</span>
            </a>
          ))}
        </div>
      )}
    </div>
  );
};
export const QRPreviewElabelsCigarScan = ({
  localQrData,
  className,
  showReview,
}) => {
  const { translatedData } = useSelector((state) => state?.language);

  const rowStyle = {
    display: "flex",
    justifyContent: "space-between",
    borderBottom: "1px solid #000",
    padding: "8px 0",
    flexWrap: "wrap",
  };

  const labelStyle = {
    fontWeight: "bold",
    flex: "1 1 40%",
    color: "#000",
  };

  const valueStyle = {
    flex: "1 1 60%",
    color: localQrData?.text_color || "#333",
  };
  const titleColor = localQrData?.title_color;
  return (
    <div
      className={`beer-container layout-content showBrowser ${className}`}
      style={{
        left: "4px",
        overflowX: "hidden",
        backgroundColor: localQrData?.color?.background,
        padding: "16px",
        borderRadius: "12px",
        maxWidth: "800px",
        margin: "0 auto",
        boxSizing: "border-box",
      }}
    >
      {localQrData?.cigar_image && (
        <div style={{ marginBottom: "16px" }}>
          <DynamicImage
            data={localQrData}
            imageKey="cigar_image"
            altText="Cigar Image"
            style={{
              width: "100%",
              height: "200px",
              objectFit: "contain",
              borderRadius: "12px",
            }}
          />
        </div>
      )}

      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          marginBottom: "16px",
          flexWrap: "wrap",
          justifyContent: "center",
        }}
      >
        <FaWineGlassAlt size={25} />
        <h2
          style={{
            display: "inline-block",
            backgroundColor: "#f9f9f9",
            color: "#333",
            padding: "6px 14px",
            borderRadius: "999px",
            fontSize: "30px",
            fontWeight: "600",
            textTransform: "capitalize",
            letterSpacing: "0.5px",
            boxShadow: "0 2px 6px rgba(0, 0, 0, 0.05)",
            border: "1px solid #ddd",
          }}
        >
          {getTranslatedField(translatedData, localQrData, "product_name")}
        </h2>
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
        {localQrData?.sku_elables && (
          <div style={rowStyle}>
            <div style={{ ...labelStyle, color: titleColor }}>
              <FaInfoCircle style={{ marginRight: "4px" }} />
              {getTranslatedField(translatedData, localQrData, "skuKey") ||
                "SKU"}
            </div>
            <div style={valueStyle}>
              {getTranslatedField(translatedData, localQrData, "sku_elables")}
            </div>
          </div>
        )}

        {localQrData?.description && (
          <div style={rowStyle}>
            <div style={{ ...labelStyle, color: titleColor }}>
              {getTranslatedField(
                translatedData,
                localQrData,
                "descriptionKey"
              ) || "Description"}
            </div>
            <div style={valueStyle}>
              {getTranslatedField(translatedData, localQrData, "description")}
            </div>
          </div>
        )}

        {localQrData?.where_it_is_made && (
          <div style={rowStyle}>
            <div style={{ ...labelStyle, color: titleColor }}>
              {getTranslatedField(translatedData, localQrData, "whereItMade") ||
                "Where It's Made"}
            </div>
            <div style={valueStyle}>
              {getTranslatedField(
                translatedData,
                localQrData,
                "where_it_is_made"
              )}
            </div>
          </div>
        )}

        {localQrData?.size && (
          <div style={rowStyle}>
            <div style={{ ...labelStyle, color: titleColor }}>
              {getTranslatedField(translatedData, localQrData, "sizeKey") ||
                "Size"}
            </div>
            <div style={valueStyle}>
              {getTranslatedField(translatedData, localQrData, "size")}
            </div>
          </div>
        )}

        {localQrData?.wrapper && (
          <div style={rowStyle}>
            <div style={{ ...labelStyle, color: titleColor }}>
              {getTranslatedField(translatedData, localQrData, "wrapperKey") ||
                "Wrapper"}
            </div>
            <div style={valueStyle}>
              {getTranslatedField(translatedData, localQrData, "wrapper")}
            </div>
          </div>
        )}

        {localQrData?.binder && (
          <div style={rowStyle}>
            <div style={{ ...labelStyle, color: titleColor }}>
              {getTranslatedField(translatedData, localQrData, "binderKey") ||
                "Binder"}
            </div>
            <div style={valueStyle}>
              {getTranslatedField(translatedData, localQrData, "binder")}
            </div>
          </div>
        )}

        {localQrData?.filler && (
          <div style={rowStyle}>
            <div style={{ ...labelStyle, color: titleColor }}>
              {getTranslatedField(translatedData, localQrData, "fillerKey") ||
                "Filler"}
            </div>
            <div style={valueStyle}>
              {getTranslatedField(translatedData, localQrData, "filler")}
            </div>
          </div>
        )}

        {localQrData?.strength && (
          <div style={rowStyle}>
            <div style={{ ...labelStyle, color: titleColor }}>
              {getTranslatedField(translatedData, localQrData, "strengthKey") ||
                "Strength"}
            </div>
            <div style={valueStyle}>
              {getTranslatedField(translatedData, localQrData, "strength")}
            </div>
          </div>
        )}

        {localQrData?.body && (
          <div style={rowStyle}>
            <div style={{ ...labelStyle, color: titleColor }}>
              {getTranslatedField(translatedData, localQrData, "bodyKey") ||
                "Body"}
            </div>
            <div style={valueStyle}>
              {getTranslatedField(translatedData, localQrData, "body")}
            </div>
          </div>
        )}

        {localQrData?.flavour_profile && (
          <div style={rowStyle}>
            <div style={{ ...labelStyle, color: titleColor }}>
              {getTranslatedField(
                translatedData,
                localQrData,
                "flavourProfileKey"
              ) || "Flavour Profile"}
            </div>
            <div style={valueStyle}>
              {getTranslatedField(
                translatedData,
                localQrData,
                "flavour_profile"
              )}
            </div>
          </div>
        )}

        {localQrData?.best_paired_with && (
          <div style={rowStyle}>
            <div style={{ ...labelStyle, color: titleColor }}>
              {getTranslatedField(
                translatedData,
                localQrData,
                "bestPairedKey"
              ) || "Best Paired With"}
            </div>
            <div style={valueStyle}>
              {getTranslatedField(
                translatedData,
                localQrData,
                "best_paired_with"
              )}
            </div>
          </div>
        )}

        {localQrData?.website && (
          <div style={rowStyle}>
            <div style={{ ...labelStyle, color: titleColor }}>
              <FaGlobe style={{ marginRight: "4px" }} />
              {getTranslatedField(
                translatedData,
                localQrData,
                "websiteElabels"
              ) || "Website"}
            </div>
            <div style={valueStyle}>
              <a
                href={localQrData.website}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  color: localQrData?.text_color,
                  textDecoration: "underline",
                }}
              >
                {localQrData.website}
              </a>
            </div>
          </div>
        )}
      </div>

      {localQrData?.elables_social && (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "12px",
            marginTop: "16px",
            borderTop: "1px solid #ddd",
            paddingTop: "16px",
          }}
        >
          {Object.entries(localQrData.elables_social).map(([key, url]) => (
            <a
              key={key}
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: "flex",
                alignItems: "center",
                textDecoration: "none",
                color: "#000",
                gap: "8px",
                fontWeight: "500",
              }}
            >
              {icons[key] || null}
              <span style={{ textTransform: "capitalize" }}>{key}</span>
            </a>
          ))}
        </div>
      )}
    </div>
  );
};
export const QRPreviewElabelsCoffeeScan = ({
  localQrData,
  className,
  showReview,
}) => {
  const { translatedData } = useSelector((state) => state?.language);

  const rowStyle = {
    display: "flex",
    justifyContent: "space-between",
    borderBottom: "1px solid #000",
    padding: "8px 0",
    flexWrap: "wrap",
  };

  const labelStyle = {
    fontWeight: "bold",
    flex: "1 1 40%",
    color: "#000",
  };

  const valueStyle = {
    flex: "1 1 60%",
    color: localQrData?.text_color || "#333",
  };
  const titleColor = localQrData?.title_color;
  return (
    <div
      className={`beer-container layout-content showBrowser ${className}`}
      style={{
        left: "4px",
        overflowX: "hidden",
        backgroundColor: localQrData?.color?.background,
        padding: "16px",
        borderRadius: "12px",
        maxWidth: "800px",
        margin: "0 auto",
        boxSizing: "border-box",
      }}
    >
      {localQrData?.coffee_image && (
        <div style={{ marginBottom: "16px" }}>
          <DynamicImage
            data={localQrData}
            imageKey="coffee_image"
            altText="Coffee Image"
            style={{
              width: "100%",
              height: "200px",
              objectFit: "contain",
              borderRadius: "12px",
            }}
          />
        </div>
      )}

      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          marginBottom: "16px",
          flexWrap: "wrap",
          justifyContent: "center",
        }}
      >
        <FaWineGlassAlt size={25} />
        <h2
          style={{
            display: "inline-block",
            backgroundColor: "#f9f9f9",
            color: "#333",
            padding: "6px 14px",
            borderRadius: "999px",
            fontSize: "30px",
            fontWeight: "600",
            textTransform: "capitalize",
            letterSpacing: "0.5px",
            boxShadow: "0 2px 6px rgba(0, 0, 0, 0.05)",
            border: "1px solid #ddd",
          }}
        >
          {getTranslatedField(translatedData, localQrData, "product_name")}
        </h2>
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
        {localQrData?.sku_elables && (
          <div style={rowStyle}>
            <div style={{ ...labelStyle, color: titleColor }}>
              <FaInfoCircle style={{ marginRight: "4px" }} />
              {getTranslatedField(translatedData, localQrData, "skuKey") ||
                "SKU"}
            </div>
            <div style={valueStyle}>
              {getTranslatedField(translatedData, localQrData, "sku_elables")}
            </div>
          </div>
        )}

        {localQrData?.description && (
          <div style={rowStyle}>
            <div style={{ ...labelStyle, color: titleColor }}>
              {getTranslatedField(
                translatedData,
                localQrData,
                "descriptionTitle"
              ) || "Description"}
            </div>
            <div style={valueStyle}>
              {getTranslatedField(translatedData, localQrData, "description")}
            </div>
          </div>
        )}

        {localQrData?.origin && (
          <div style={rowStyle}>
            <div style={{ ...labelStyle, color: titleColor }}>
              {getTranslatedField(translatedData, localQrData, "originKey") ||
                "Origin"}
            </div>
            <div style={valueStyle}>
              {getTranslatedField(translatedData, localQrData, "origin")}
            </div>
          </div>
        )}

        {localQrData?.farm && (
          <div style={rowStyle}>
            <div style={{ ...labelStyle, color: titleColor }}>
              {getTranslatedField(translatedData, localQrData, "farmKey") ||
                "Farm"}
            </div>
            <div style={valueStyle}>
              {getTranslatedField(translatedData, localQrData, "farm")}
            </div>
          </div>
        )}

        {localQrData?.altitude != null && (
          <div style={rowStyle}>
            <div style={{ ...labelStyle, color: titleColor }}>
              {getTranslatedField(translatedData, localQrData, "altitudeKey") ||
                "Altitude"}
            </div>
            <div style={valueStyle}>{localQrData.altitude}m</div>
          </div>
        )}

        {localQrData?.roast && (
          <div style={rowStyle}>
            <div style={{ ...labelStyle, color: titleColor }}>
              {getTranslatedField(translatedData, localQrData, "roastKey") ||
                "Roast"}
            </div>
            <div style={valueStyle}>
              {getTranslatedField(translatedData, localQrData, "roast")}
            </div>
          </div>
        )}

        {localQrData?.flavour && (
          <div style={rowStyle}>
            <div style={{ ...labelStyle, color: titleColor }}>
              {getTranslatedField(translatedData, localQrData, "flavourKey") ||
                "Flavour"}
            </div>
            <div style={valueStyle}>
              {getTranslatedField(translatedData, localQrData, "flavour")}
            </div>
          </div>
        )}

        {localQrData?.task_notes && (
          <div style={rowStyle}>
            <div style={{ ...labelStyle, color: titleColor }}>
              {getTranslatedField(translatedData, localQrData, "taskNoteKey") ||
                "Task Notes"}
            </div>
            <div style={valueStyle}>
              {getTranslatedField(translatedData, localQrData, "task_notes")}
            </div>
          </div>
        )}

        {localQrData?.ingredients && (
          <div style={rowStyle}>
            <div style={{ ...labelStyle, color: titleColor }}>
              {getTranslatedField(
                translatedData,
                localQrData,
                "ingredientsKey"
              ) || "Ingredients"}
            </div>
            <div style={valueStyle}>
              {getTranslatedField(translatedData, localQrData, "ingredients")}
            </div>
          </div>
        )}

        {localQrData?.storage && (
          <div style={rowStyle}>
            <div style={{ ...labelStyle, color: titleColor }}>
              {getTranslatedField(translatedData, localQrData, "storageKey") ||
                "Storage"}
            </div>
            <div style={valueStyle}>
              {getTranslatedField(translatedData, localQrData, "storage")}
            </div>
          </div>
        )}

        {localQrData?.organic !== false && (
          <div style={rowStyle}>
            <div style={{ ...labelStyle, color: titleColor }}>
              {getTranslatedField(translatedData, localQrData, "organicKey") ||
                "Organic"}
            </div>
            <div style={valueStyle}>
              {localQrData.organic ? (
                <FaCheck style={{ color: "green" }} />
              ) : (
                <FaTimes style={{ color: "red" }} />
              )}
            </div>
          </div>
        )}

        {localQrData?.free_trade !== false && (
          <div style={rowStyle}>
            <div style={{ ...labelStyle, color: titleColor }}>
              {getTranslatedField(
                translatedData,
                localQrData,
                "fareTradeKey"
              ) || "Fair Trade"}
            </div>
            <div style={valueStyle}>
              {localQrData.free_trade ? (
                <FaCheck style={{ color: "green" }} />
              ) : (
                <FaTimes style={{ color: "red" }} />
              )}
            </div>
          </div>
        )}

        {localQrData?.website && (
          <div style={rowStyle}>
            <div style={{ ...labelStyle, color: titleColor }}>
              <FaGlobe style={{ marginRight: "4px" }} />
              {getTranslatedField(
                translatedData,
                localQrData,
                "websiteElabels"
              ) || "Website"}
            </div>
            <div style={valueStyle}>
              <a
                href={localQrData.website}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  color: localQrData?.text_color,
                  textDecoration: "underline",
                }}
              >
                {localQrData.website}
              </a>
            </div>
          </div>
        )}
      </div>

      {localQrData?.nutrition_image && (
        <div style={{ marginTop: "16px" }}>
          <DynamicImage
            data={localQrData}
            imageKey="nutrition_image"
            altText="Nutrition Information"
            style={{
              width: "100%",
              height: "120px",
              objectFit: "contain",
              borderRadius: "12px",
            }}
          />
        </div>
      )}

      {localQrData?.elables_social && (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "12px",
            marginTop: "16px",
            borderTop: "1px solid #ddd",
            paddingTop: "16px",
          }}
        >
          {Object.entries(localQrData.elables_social).map(([key, url]) => (
            <a
              key={key}
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: "flex",
                alignItems: "center",
                textDecoration: "none",
                color: "#000",
                gap: "8px",
                fontWeight: "500",
              }}
            >
              {icons[key] || null}
              <span style={{ textTransform: "capitalize" }}>{key}</span>
            </a>
          ))}
        </div>
      )}
    </div>
  );
};
export const QRPreviewElabelsFoodScan = ({
  localQrData,
  className,
  showReview,
}) => {
  const { translatedData } = useSelector((state) => state?.language);
  const titleColor = localQrData?.title_color;
  const rowStyle = {
    display: "flex",
    justifyContent: "space-between",
    borderBottom: "1px solid #000",
    padding: "8px 0",
    flexWrap: "wrap",
  };

  const labelStyle = {
    fontWeight: "bold",
    flex: "1 1 40%",
    color: "#000",
  };

  const valueStyle = {
    flex: "1 1 60%",
    color: localQrData?.text_color || "#333",
  };

  return (
    <div
      className={`beer-container layout-content showBrowser ${className}`}
      style={{
        left: "4px",
        overflowX: "hidden",
        backgroundColor: localQrData?.color?.background,
        padding: "16px",
        borderRadius: "12px",
        maxWidth: "800px",
        margin: "0 auto",
        boxSizing: "border-box",
      }}
    >
      {localQrData?.food_image && (
        <div style={{ marginBottom: "16px" }}>
          <DynamicImage
            data={localQrData}
            imageKey="food_image"
            altText="Food Image"
            style={{
              width: "100%",
              height: "200px",
              objectFit: "contain",
              borderRadius: "12px",
            }}
          />
        </div>
      )}

      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          marginBottom: "16px",
          flexWrap: "wrap",
          justifyContent: "center",
        }}
      >
        <FaWineGlassAlt size={25} />
        <h2
          style={{
            display: "inline-block",
            backgroundColor: "#f9f9f9",
            color: "#333",
            padding: "6px 14px",
            borderRadius: "999px",
            fontSize: "30px",
            fontWeight: "600",
            textTransform: "capitalize",
            letterSpacing: "0.5px",
            boxShadow: "0 2px 6px rgba(0, 0, 0, 0.05)",
            border: "1px solid #ddd",
          }}
        >
          {getTranslatedField(translatedData, localQrData, "product_name")}
        </h2>
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
        {localQrData?.sku_elables && (
          <div style={rowStyle}>
            <div style={{ ...labelStyle, color: titleColor }}>
              <FaInfoCircle style={{ marginRight: "4px" }} />
              {getTranslatedField(translatedData, localQrData, "skuKey") ||
                "SKU"}
            </div>
            <div style={valueStyle}>
              {getTranslatedField(translatedData, localQrData, "sku_elables")}
            </div>
          </div>
        )}

        {localQrData?.cuisine && (
          <div style={rowStyle}>
            <div style={{ ...labelStyle, color: titleColor }}>
              <FaInfoCircle style={{ marginRight: "4px" }} />
              {getTranslatedField(translatedData, localQrData, "cuisineKey") ||
                "Cuisine"}
            </div>
            <div style={valueStyle}>
              {getTranslatedField(translatedData, localQrData, "cuisine")}
            </div>
          </div>
        )}

        {localQrData?.ingredients && (
          <div style={rowStyle}>
            <div style={{ ...labelStyle, color: titleColor }}>
              {getTranslatedField(
                translatedData,
                localQrData,
                "ingredientsKey"
              ) || "Ingredients"}
            </div>
            <div style={valueStyle}>
              {getTranslatedField(translatedData, localQrData, "ingredients")}
            </div>
          </div>
        )}

        {localQrData?.size && (
          <div style={rowStyle}>
            <div style={{ ...labelStyle, color: titleColor }}>
              {getTranslatedField(
                translatedData,
                localQrData,
                "servingSizeKey"
              ) || "Serving Size"}
            </div>
            <div style={valueStyle}>
              {getTranslatedField(translatedData, localQrData, "size")}
            </div>
          </div>
        )}

        {localQrData?.clories && (
          <div style={rowStyle}>
            <div style={{ ...labelStyle, color: titleColor }}>
              {getTranslatedField(translatedData, localQrData, "caloriesKey") ||
                "Calories"}
            </div>
            <div style={valueStyle}>{localQrData.clories}</div>
          </div>
        )}

        {localQrData?.website && (
          <div style={rowStyle}>
            <div style={{ ...labelStyle, color: titleColor }}>
              <FaGlobe style={{ marginRight: "4px" }} />
              {getTranslatedField(
                translatedData,
                localQrData,
                "websiteElabels"
              ) || "Website"}
            </div>
            <div style={valueStyle}>
              <a
                href={localQrData.website}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  color: localQrData?.text_color,
                  textDecoration: "underline",
                }}
              >
                {localQrData.website}
              </a>
            </div>
          </div>
        )}
      </div>

      {localQrData?.elables_social && (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "12px",
            marginTop: "16px",
            borderTop: "1px solid #ddd",
            paddingTop: "16px",
          }}
        >
          {Object.entries(localQrData.elables_social).map(([key, url]) => (
            <a
              key={key}
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: "flex",
                alignItems: "center",
                textDecoration: "none",
                color: "#000",
                gap: "8px",
                fontWeight: "500",
              }}
            >
              {icons[key] || null}
              <span style={{ textTransform: "capitalize" }}>{key}</span>
            </a>
          ))}
        </div>
      )}
    </div>
  );
};
export const QRPreviewElabelsProductScan = ({
  localQrData,
  className,
  showReview,
}) => {
  const { translatedData } = useSelector((state) => state?.language);

  const titleColor = localQrData?.title_color;
  const rowStyle = {
    display: "flex",
    justifyContent: "space-between",
    borderBottom: "1px solid #000",
    padding: "8px 0",
    flexWrap: "wrap",
  };

  const labelStyle = {
    fontWeight: "bold",
    flex: "1 1 40%",
    color: "#000",
  };

  const valueStyle = {
    flex: "1 1 60%",
    color: localQrData?.text_color || "#333",
  };

  return (
    <div
      className={`beer-container layout-content showBrowser ${className}`}
      style={{
        left: "4px",
        overflowX: "hidden",
        backgroundColor: localQrData?.color?.background,
        padding: "16px",
        borderRadius: "12px",
        maxWidth: "800px",
        margin: "0 auto",
        boxSizing: "border-box",
      }}
    >
      {localQrData?.product_image && (
        <div style={{ marginBottom: "16px" }}>
          <DynamicImage
            data={localQrData}
            imageKey="product_image"
            altText="Product Image"
            style={{
              width: "100%",
              height: "200px",
              objectFit: "contain",
              borderRadius: "12px",
            }}
          />
        </div>
      )}

      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          marginBottom: "16px",
          flexWrap: "wrap",
          justifyContent: "center",
        }}
      >
        <FaWineGlassAlt size={25} />
        <h2
          style={{
            display: "inline-block",
            backgroundColor: "#f9f9f9",
            color: "#333",
            padding: "6px 14px",
            borderRadius: "999px",
            fontSize: "30px",
            fontWeight: "600",
            textTransform: "capitalize",
            letterSpacing: "0.5px",
            boxShadow: "0 2px 6px rgba(0, 0, 0, 0.05)",
            border: "1px solid #ddd",
          }}
        >
          {getTranslatedField(translatedData, localQrData, "product_name")}
        </h2>
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
        {localQrData?.sku_elables && (
          <div style={rowStyle}>
            <div style={{ ...labelStyle, color: titleColor }}>
              <FaInfoCircle style={{ marginRight: "4px" }} />
              {getTranslatedField(translatedData, localQrData, "skuKey") ||
                "SKU"}
            </div>
            <div style={valueStyle}>
              {getTranslatedField(translatedData, localQrData, "sku_elables")}
            </div>
          </div>
        )}

        {localQrData?.description && (
          <div style={rowStyle}>
            <div style={{ ...labelStyle, color: titleColor }}>
              {getTranslatedField(
                translatedData,
                localQrData,
                "descriptionKey"
              ) || "Description"}
            </div>
            <div style={valueStyle}>
              {getTranslatedField(translatedData, localQrData, "description")}
            </div>
          </div>
        )}

        {localQrData?.directions && (
          <div style={rowStyle}>
            <div style={{ ...labelStyle, color: titleColor }}>
              {getTranslatedField(
                translatedData,
                localQrData,
                "directionKey"
              ) || "Directions"}
            </div>
            <div style={valueStyle}>
              {getTranslatedField(translatedData, localQrData, "directions")}
            </div>
          </div>
        )}

        {localQrData?.brand && (
          <div style={rowStyle}>
            <div style={{ ...labelStyle, color: titleColor }}>
              {getTranslatedField(translatedData, localQrData, "brandKey") ||
                "Brand"}
            </div>
            <div style={valueStyle}>
              {getTranslatedField(translatedData, localQrData, "brand")}
            </div>
          </div>
        )}

        {localQrData?.category && (
          <div style={rowStyle}>
            <div style={{ ...labelStyle, color: titleColor }}>
              {getTranslatedField(translatedData, localQrData, "categoryKey") ||
                "Category"}
            </div>
            <div style={valueStyle}>
              {getTranslatedField(translatedData, localQrData, "category")}
            </div>
          </div>
        )}

        {localQrData?.price != 0 && (
          <div style={rowStyle}>
            <div style={{ ...labelStyle, color: titleColor }}>
              {getTranslatedField(translatedData, localQrData, "priceKey") ||
                "Price"}
            </div>
            <div style={valueStyle}>
              {getTranslatedField(translatedData, localQrData, "price")}
            </div>
          </div>
        )}

        {localQrData?.warning && (
          <div style={rowStyle}>
            <div style={{ ...labelStyle, color: titleColor }}>
              <FaExclamationCircle style={{ marginRight: "4px" }} />
              {getTranslatedField(translatedData, localQrData, "warningKey") ||
                "Warning"}
            </div>
            <div style={valueStyle}>
              {getTranslatedField(translatedData, localQrData, "warning")}
            </div>
          </div>
        )}
      </div>

      {localQrData?.elables_social && (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "12px",
            marginTop: "16px",
            borderTop: "1px solid #ddd",
            paddingTop: "16px",
          }}
        >
          {Object.entries(localQrData.elables_social).map(([key, url]) => (
            <a
              key={key}
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: "flex",
                alignItems: "center",
                textDecoration: "none",
                color: "#000",
                gap: "8px",
                fontWeight: "500",
              }}
            >
              {icons[key] || null}
              <span style={{ textTransform: "capitalize" }}>{key}</span>
            </a>
          ))}
        </div>
      )}
    </div>
  );
};
